// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:06.990Z
// Property: Icon at Broken Arrow Apartments (ID: 6767906449167041)
// Collections: 32 amenities, 6 floorplans (live), 58 photos, 77 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167041",
  "property_external_id": "475538",
  "property_zillow_url": "https://www.zillow.com/apartments/broken-arrow-ok/icon-at-broken-arrow-apartments/5xTBHk/",
  "property_apartments_url": "https://www.apartments.com/broken-arrow-ok/",
  "property_google_business_url": "https://www.google.com/maps/place/Icon+at+Broken+Arrow/data=!4m2!3m1!1s0x0:0x1e29d484a73f14f0?sa=X&ved=2ahUKEwiLhuTehYOTAxVAg4kEHbj-A2cQ_BJ6BAhDEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "icon-at-broken-arrow-apartments",
  "property_name": "Icon at Broken Arrow Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/icon-at-broken-arrow/",
  "property_domain": null,
  "property_address": "4801 S. Elm Pl.",
  "property_full_address": "4801 S. Elm Pl., Broken Arrow, OK, 74011",
  "property_address_1": "4801 S. Elm Pl.",
  "property_address_2": null,
  "property_address_city": "Broken Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74011",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": null,
  "property_address_latitude": "36.0027",
  "property_address_longitude": "-95.7972",
  "property_email": "IconBA@caseusa.com",
  "property_phone": "(539) 224-2962",
  "property_call_tracking_phone": "833-557-1679",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Icon at Broken Arrow Apartments, where comfort meets convenience in the heart of Broken Arrow, OK. Choose from stylish one and two-bedroom floor plans, enjoy our pet-friendly community, and relax by the swimming pool. Secure your new home today and schedule a tour to experience it all! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your New Home at Icon at Broken Arrow Apartments**\n\nWelcome to Icon at Broken Arrow Apartments, where modern living meets comfort and convenience in the heart of Broken Arrow, OK. Our thoughtfully designed floor plans offer both one-bedroom and two-bedroom options, perfect for individuals or families seeking a vibrant community to call home. \n\nExperience resort-style amenities that elevate your lifestyle. Enjoy sunny afternoons at our sparkling swimming pool with a spacious sun deck, host delightful gatherings at our picnic area complete with gas grills, or unwind at our onsite dog park, perfect for your furry friends. Stay active with our 24-hour fitness center, or relax with a gourmet coffee in our internet café. \n\nYour peace of mind is our priority. From limited access gates and 24-hour emergency maintenance to thoughtful plumbing options, we ensure a secure and stress-free living experience. Our apartments feature wood-style flooring in kitchens and bathrooms, energy-efficient stainless-steel appliances, and plush carpeting, all designed for your comfort. Select units even boast vaulted ceilings and cozy wood-burning fireplaces, making your space uniquely yours.\n\nWith ample closet space, air conditioning, and washer & dryer connections, our homes combine function with style. Plus, we are proud to be a pet-friendly community, with courtyards equipped with pet stations for your convenience.\n\nDon’t wait any longer to find your dream home. Browse our availability today or schedule a tour to visit Icon at Broken Arrow Apartments. Experience the perfect blend of comfort, community, and style—your new life awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-230f-7241-a5ae-4baff0538188.webp",
  "property_featured_image_media": {
    "alt_text": "The Icon apartments monument sign.",
    "public_id": "019fb453-230f-7241-a5ae-4baff0538188",
    "storage_key": "property/6767906449167041/019fb453-230f-7241-a5ae-4baff0538188.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "35",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "75",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs allowed, maximum 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed, maximum 2 pets per unit. One-time pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://iconatbrokenarrowapartments.securecafe.com/onlineleasing/icon-at-broken-arrow-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://iconatbrokenarrowapartments.securecafe.com/residentservices/icon-at-broken-arrow-apartments/userlogin.aspx",
  "property_apply_now_url": "https://iconatbrokenarrowapartments.securecafe.com/onlineleasing/icon-at-broken-arrow-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-c309-76ca-b5b8-ebc455dda09a.webp",
  "property_primary_logo_media": {
    "alt_text": "The Icon at Broken Arrow Urban Apartments logo",
    "public_id": "019cfb51-c309-76ca-b5b8-ebc455dda09a",
    "storage_key": "property/6767906449167041/019cfb51-c309-76ca-b5b8-ebc455dda09a.webp",
    "width": 300,
    "height": 120
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-d6af-714a-99f0-df0ea356fba7.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Icon at Broken Arrow Urban Apartments logo.",
    "public_id": "019cfb52-d6af-714a-99f0-df0ea356fba7",
    "storage_key": "property/6767906449167041/019cfb52-d6af-714a-99f0-df0ea356fba7.webp",
    "width": 300,
    "height": 120
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-e049-779b-b335-c86c50e29e6a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Icon at Broken Arrow Urban Apartments logo.",
    "public_id": "019cfb52-e049-779b-b335-c86c50e29e6a",
    "storage_key": "property/6767906449167041/019cfb52-e049-779b-b335-c86c50e29e6a.webp",
    "width": 300,
    "height": 120
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#5d7274",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1139 - 1509",
  "property_price_min": "1139",
  "property_price_max": "1509",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/media/set/?vanity=IconatBrokenArrow&set=a.588186599542918",
  "property_instagram_url": "https://www.instagram.com/iconbaapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJAS4p7yKJtocR8BQ_p4TUKR4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment+Complex&find_loc=Broken+Arrow%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/place/Icon-at-Broken-Arrow-21568226271709882",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Icon at Broken Arrow Apartments",
  "property_home_romance_title": "Embrace Your New Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Icon at Broken Arrow Apartments, where comfort meets convenience in every detail. Choose from spacious one- or two-bedroom layouts, featuring upscale amenities like a shimmering pool, an inviting picnic area, and a pet-friendly atmosphere. Elevate your lifestyle with our modern finishes and exceptional community offerings!",
  "property_home_floorplans_blurb": "Welcome to Icon at Broken Arrow Apartments, where modern design meets comfort in the heart of Broken Arrow, OK. Picture yourself in a stylish space tailored to your needs. Browse our available apartment homes today and uncover the perfect floor plan that complements your lifestyle and aspirations.",
  "property_home_gallery_blurb": "Welcome to Icon at Broken Arrow Apartments, where comfort meets style. Choose from spacious one or two-bedroom floor plans, and enjoy premier amenities like a refreshing swimming pool, pet-friendly courtyards, and a vibrant picnic area. Picture yourself thriving in this perfect blend of luxury and convenience in Broken Arrow, OK!",
  "property_home_neighborhood_blurb": "At Icon at Broken Arrow Apartments, your vibrant lifestyle unfolds with enriching local treasures. Nestled near parks, libraries, and community spaces like the Hardesty Regional Library and the Rose District Splash Pad, every day here is an adventure. Embrace a perfect blend of comfort and exploration in Broken Arrow, OK!",
  "property_home_reviews_blurb": "At Icon at Broken Arrow Apartments, residents rave about the “friendly atmosphere and spacious layouts.” Nestled in the heart of Broken Arrow, OK, our community offers more than just a home—it's a lifestyle. See what our residents have to say about living at our community and join us today!",
  "property_neighborhood_blurb": "Nestled in vibrant Broken Arrow, Icon at Broken Arrow Apartments offers easy access to a wealth of neighborhood gems. Enjoy outdoor adventures at Haikey Creek Park or immerse yourself in history at the Military History Museum. Conveniently near top-notch schools and fitness centers, everything you need is just moments away.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience the lifestyle you deserve at Icon at Broken Arrow Apartments. Enjoy spacious two- and one-bedroom floor plans, a vibrant picnic area with gas grills, and a resort-style swimming pool. Whether unwinding at our onsite dog park or energizing in the 24-hour fitness center, your perfect home awaits!",
  "property_applynow_blurb": "At Icon at Broken Arrow Apartments, comfort meets convenience in our thoughtfully designed one- and two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a relaxing swimming pool, a 24-hour fitness center, and a pet-friendly dog park. Start your journey to a remarkable new home today—lease online!",
  "property_contactus_blurb": "At Icon at Broken Arrow Apartments, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Nestled in vibrant Broken Arrow, OK, our community invites you to experience modern living with a unique touch. Have questions? Our friendly leasing team is here to help you find your perfect home!",
  "property_faqs_blurb": "At Icon at Broken Arrow Apartments, our diverse floor plans, including spacious one and two-bedroom options, cater to your unique lifestyle. Nestled in Broken Arrow, OK, we invite you to visit our Frequently Asked Questions page for insights that’ll help you feel right at home in our vibrant community.",
  "property_floorplans_blurb": "At Icon at Broken Arrow Apartments, unique living begins with thoughtfully designed floor plans. Choose from spacious one-bedroom and two-bedroom options, tailored for comfort and style. Your next chapter awaits in Broken Arrow, OK—browse our available apartment homes and uncover the perfect layout that fits your lifestyle.",
  "property_gallery_blurb": "At Icon at Broken Arrow Apartments, vibrant living meets modern comfort. Picture yourself enjoying sunny days at our swimming pool and relaxing evenings by the gas grills in our picnic area. With spacious floor plans and exceptional amenities like an onsite dog park and 24-hour fitness center, your perfect home awaits!",
  "property_interactivemap_blurb": "At Icon at Broken Arrow Apartments, your ideal home awaits. Choose from stylish one or two-bedroom floor plans, complemented by luxurious amenities like a swimming pool, 24-hour fitness center, and serene picnic areas. Navigate our interactive community map to find your perfect sanctuary in Broken Arrow, OK!",
  "property_pets_blurb": "At Icon at Broken Arrow Apartments, your furry friends are part of the family! With a welcoming atmosphere for up to two pets per unit, you can enjoy the convenience of pet-friendly living paired with modern amenities. Experience life where comfort meets community in Broken Arrow, OK.",
  "property_referafriend_blurb": "At Icon at Broken Arrow Apartments, your perfect living space awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to fit your lifestyle. Great friends make great neighbors—refer a friend today and enjoy the vibrant community together, right here in Broken Arrow, OK!",
  "property_residentaccess_blurb": "Welcome to Icon at Broken Arrow Apartments, where comfort meets convenience in Broken Arrow, OK. Choose from our thoughtfully designed one and two-bedroom floor plans. Ready to simplify your living experience? Access your resident portal now to manage rent, schedule maintenance, and enjoy a stress-free lifestyle!",
  "property_reviews_blurb": "At Icon at Broken Arrow Apartments, residents revel in a vibrant lifestyle, praising our friendly staff and modern amenities. One resident enthusiastically shares, \"Living here feels like home!\" Dive into our glowing reviews and see why our community is the perfect fit for your next chapter.",
  "property_created_at": "1770683896847",
  "property_scheduletour_blurb": "At Icon at Broken Arrow Apartments, experience spacious living in our thoughtfully designed one and two-bedroom floor plans. Nestled in vibrant Broken Arrow, OK, your ideal home awaits. Ready to see why our residents love calling this community home? Schedule a tour today and hear their stories!",
  "property_thankyou_blurb": "Thank you for reaching out to Icon at Broken Arrow Apartments! Your interest in our charming one and two-bedroom floor plans is appreciated. A team member will connect with you soon to guide you through finding your perfect home in Broken Arrow, where comfort and style come together seamlessly.",
  "property_virtualtours_blurb": "Step into the stylish lifestyle at Icon at Broken Arrow Apartments, where spacious one and two-bedroom floor plans await your personal touch. Embrace comfort and modern living in Broken Arrow, OK. Experience it all from the comfort of your home—take a virtual tour of our vibrant community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Icon at Broken Arrow Apartments",
  "property_seo_title_home": "Icon at Broken Arrow Apartments |  Apartments in Broken Arrow, OK",
  "property_seo_description_home": "Find comfort and style at Icon at Broken Arrow! Choose from spacious one- or two-bedroom floor plans with top-tier amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Icon at Broken Arrow Apartments! Choose from stylish one- and two-bedroom floor plans designed for your comfort and lifestyle.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Icon at Broken Arrow! Enjoy spacious floor plans, stunning amenities, and a pet-friendly lifestyle. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, OK",
  "property_seo_description_gallery": "Discover life at Icon at Broken Arrow Apartments: spacious floor plans, a vibrant community, and premium amenities await your perfect home!",
  "property_seo_title_virtualtours": "Virtual Tours | Icon at Broken Arrow Apartments Apartments",
  "property_seo_description_virtualtours": "Step into the future of living at Icon at Broken Arrow Apartments. Experience our stunning one- and two-bedroom layouts with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Icon at Broken Arrow Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Icon at Broken Arrow Apartments! Enjoy spacious layouts, pet-friendly amenities, and a vibrant community in OK.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, OK",
  "property_seo_description_neighborhood": "Experience the best of Broken Arrow at Icon at Broken Arrow Apartments! Uncover local gems, parks, and dining just steps away from your new home.",
  "property_seo_title_contact": "Contact Us | Icon at Broken Arrow Apartments",
  "property_seo_description_contact": "Connect with the leasing team at Icon at Broken Arrow Apartments for inquiries about our spacious one and two-bedroom floor plans in Broken Arrow, OK!",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, OK",
  "property_seo_description_faqs": "Find quick answers about Icon at Broken Arrow Apartments! From amenities to floor plans, get insights on living in our vibrant, pet-friendly community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, OK",
  "property_seo_description_reviews": "Join the Icon at Broken Arrow Apartments community! Relax by the pool, connect with neighbors, and enjoy stylish living. Read reviews!",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, OK",
  "property_seo_description_applynow": "Discover your ideal home at Icon at Broken Arrow! Enjoy spacious layouts, a pet-friendly vibe, and great amenities like a pool and fitness center!",
  "property_seo_title_residentaccess": "Resident Access | Icon at Broken Arrow Apartments",
  "property_seo_description_residentaccess": "Unlock easy living at Icon at Broken Arrow Apartments! Log in to your resident portal for rent payments, maintenance requests, and all your community needs.",
  "property_seo_title_referafriend": "Refer A Friend | Icon at Broken Arrow Apartments",
  "property_seo_description_referafriend": "Refer a friend to Icon at Broken Arrow Apartments! Great friends make great neighbors—join our vibrant community in Broken Arrow, OK, for a better lifestyle!",
  "property_seo_title_scheduletour": "Schedule a Tour | Icon at Broken Arrow Apartments",
  "property_seo_description_scheduletour": "Experience modern living at Icon at Broken Arrow Apartments. Schedule your tour today and find your perfect home in a vibrant community tailored for you!",
  "property_seo_title_privacy": "Privacy Policy | Icon at Broken Arrow Apartments",
  "property_seo_description_privacy": "Your peace of mind matters! Learn how Icon at Broken Arrow Apartments protects your privacy. Read our comprehensive privacy policy for all the details.",
  "property_seo_title_accessibility": "Website Accessibility | Icon at Broken Arrow Apartments",
  "property_seo_description_accessibility": "At Icon at Broken Arrow Apartments, we champion digital inclusion, ensuring our community is accessible for everyone. Join us in creating a welcoming space!",
  "property_seo_title_sitemap": "Sitemap | Icon at Broken Arrow Apartments",
  "property_seo_description_sitemap": "Explore our sitemap for Icon at Broken Arrow Apartments and discover every corner of our vibrant Broken Arrow community!",
  "property_seo_title_thankyou": "Thank You | Icon at Broken Arrow Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Icon at Broken Arrow Apartments means a lot to us. Our team will be in touch soon with all the details you need.",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865307854",
  "amenities": [
    {
      "id": "ec_d9b83f1ff9356cdb049b7b93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396665",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_129b22e76bb3146e0d4ee32a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396666",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eae6ed0a48915914ce68b101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396667",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a1ff8d27418476cc22a8152b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396668",
      "title": "Courtyards with Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e6d4c32f915c0c4e40bcf5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396669",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e59c6028d1b61075eba07712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396670",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d12e865afa04531de18f92aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396671",
      "title": "Swimming Pool with Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c1037b9c3a54d62c41ff8ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396672",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cc7fc2e20ff2ddfb3975246",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396673",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42c0b3313d4cb5a58425b83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396674",
      "title": "Internet Cafe with Gourmet Coffee & Tea Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b81c576ed9700e6698079b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396675",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_005e9bbaa1fcf62e04bf423e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127396676",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07d34f8bf21b723d16e6eba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "128042538",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_699eacbb5e98b673e9fe94a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398148",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53c1acb1b08663f9af04e38f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398150",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40e655048429f92c3875f356",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398151",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f57e15f36d9f5de508168e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398152",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14665b5338bd1f05685c0ca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398153",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b6002aa4b6ca36daa465321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398154",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d8dd2a62b846f0a21b2a4b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398155",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af9b930b7a6ebc0de06aa9a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398156",
      "title": "Wood-Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b1152aa3330073f40a303f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398157",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ba347dfdd8fb4c2dcc0f8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398158",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9d2000b08a60c9c0470db76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398159",
      "title": "Private Balcony or Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_671926849ee3ad36daf4c5d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398160",
      "title": "Side-by-Side Refrigerator with Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83788c873ad9281d3d27fc04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398161",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e21395335a6d4b2fc25a247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398162",
      "title": "Handicapped-Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7fa5e7c8d110af7ef20d5ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398163",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75112d31ea41201c320adf3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398164",
      "title": "Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50cd9bea182435d45a5c3fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398165",
      "title": "Loft-Style Living*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c26474419d00517f065a98e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398166",
      "title": "Designer Colors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5d093d78a5d875366de9fbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "yardi",
      "external_id": "127398167",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3a3afccb-ff19-4a26-b2b5-994837838ddb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-74f4-76d8-afb5-34dba67bdb24.webp",
      "image_media": {
        "alt_text": "Brick entry sign for The Icon apartment community with landscaped shrubs and a gated entrance.",
        "public_id": "019fb452-74f4-76d8-afb5-34dba67bdb24",
        "storage_key": "property/6767906449167041/019fb452-74f4-76d8-afb5-34dba67bdb24.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior entry sign for The Icon apartments with landscaped border and gated perimeter.",
      "link": "",
      "alt_text": "Brick entry sign for The Icon apartment community with landscaped shrubs and a gated entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c384-75ee-96df-921bd3559253.webp"
    },
    {
      "id": "custom_eca0870a-d103-4cd2-b27a-3c88ebcd9390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-74ba-7442-b70f-f40bf9f3d86c.webp",
      "image_media": {
        "alt_text": "The exterior entrance of the Icon apartment complex with a walkway leading to the front doors.",
        "public_id": "019fb452-74ba-7442-b70f-f40bf9f3d86c",
        "storage_key": "property/6767906449167041/019fb452-74ba-7442-b70f-f40bf9f3d86c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to the Icon apartment complex, where you can take a self-guided tour at your own pace.",
      "link": "",
      "alt_text": "The exterior entrance of the Icon apartment complex with a walkway leading to the front doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5d90-7607-96cf-98894250cd5a.webp"
    },
    {
      "id": "custom_cf1b8812-f43c-414a-a442-eee419e2183e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-75a9-72a4-a521-e6a6a7166804.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment community building with a manicured lawn and the \"The Icon\" sign.",
        "public_id": "019fb452-75a9-72a4-a521-e6a6a7166804",
        "storage_key": "property/6767906449167041/019fb452-75a9-72a4-a521-e6a6a7166804.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Front exterior of the apartment community showing brick columns, landscaping, and signage.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment community building with a manicured lawn and the \"The Icon\" sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c37c-77ce-a584-25234eacea82.webp"
    },
    {
      "id": "custom_2dd7777e-ba6f-4665-9f7b-1fae5ef1a5a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-74f6-7657-a63b-8be9a3fcd04f.webp",
      "image_media": {
        "alt_text": "Outdoor community courtyard with trees, benches, and planters between apartment buildings.",
        "public_id": "019fb452-74f6-7657-a63b-8be9a3fcd04f",
        "storage_key": "property/6767906449167041/019fb452-74f6-7657-a63b-8be9a3fcd04f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A landscaped outdoor courtyard in a multifamily community featuring seating areas, trees, and flower beds.",
      "link": "",
      "alt_text": "Outdoor community courtyard with trees, benches, and planters between apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c378-7198-9093-697ba5e9d7e7.webp"
    },
    {
      "id": "custom_fc91c278-06f7-4a63-a42a-9b31d88d8180",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-7f03-76c8-8be0-d4707c1c36c3.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment and benches, fenced yard.",
        "public_id": "019fb452-7f03-76c8-8be0-d4707c1c36c3",
        "storage_key": "property/6767906449167041/019fb452-7f03-76c8-8be0-d4707c1c36c3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, complete with agility equipment for your furry friends and comfortable benches for relaxation.",
      "link": "",
      "alt_text": "Dog park area with agility equipment and benches, fenced yard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-8157-729c-9071-5b7c1e4b9b58.webp"
    },
    {
      "id": "custom_289df289-56cb-4bfe-b2e3-3a0d2cad8ff3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-7f1d-772c-9360-19da0af67366.webp",
      "image_media": {
        "alt_text": "Outdoor gathering area with grills, picnic tables, umbrellas, and a pool in the background.",
        "public_id": "019fb452-7f1d-772c-9360-19da0af67366",
        "storage_key": "property/6767906449167041/019fb452-7f1d-772c-9360-19da0af67366.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining in our community's barbecue and picnic area, complete with grills and comfortable seating, adjacent to a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor gathering area with grills, picnic tables, umbrellas, and a pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-6c48-7268-a37d-4f0a7dbfa9ec.webp"
    },
    {
      "id": "custom_7de5e62b-7d3e-4887-9f45-de85ebdda014",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8003-76a0-a21a-aa6facd1fbfc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fb452-8003-76a0-a21a-aa6facd1fbfc",
        "storage_key": "property/6767906449167041/019fb452-8003-76a0-a21a-aa6facd1fbfc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5960-77ac-b95f-538ba4d2ac1f.webp"
    },
    {
      "id": "custom_fde159b3-742d-4eaf-a3d9-3a5026cb17ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8001-763b-81ef-d0999a282ba7.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with red lounge chairs and surrounding deck.",
        "public_id": "019fb452-8001-763b-81ef-d0999a282ba7",
        "storage_key": "property/6767906449167041/019fb452-8001-763b-81ef-d0999a282ba7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A bright outdoor pool area at the apartment community, featuring a large pool, red chaise lounges, and surrounding amenities.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with red lounge chairs and surrounding deck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-cda7-769e-b988-acaba2b3b041.webp"
    },
    {
      "id": "custom_26b61053-b161-4eaf-9929-d9310bc14eff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8973-7264-afed-c7978972018c.webp",
      "image_media": {
        "alt_text": "Interior view of a multifamily property's grand entrance with double doors, large windows, and decorative elements.",
        "public_id": "019fb452-8973-7264-afed-c7978972018c",
        "storage_key": "property/6767906449167041/019fb452-8973-7264-afed-c7978972018c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Step into luxury at our multifamily property's elegant entrance, featuring grand double doors, spacious windows, and a beautifully decorated foyer.",
      "link": "",
      "alt_text": "Interior view of a multifamily property's grand entrance with double doors, large windows, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5d3e-75da-ad3c-d9321db42efe.webp"
    },
    {
      "id": "custom_fbd0d9dc-48be-4625-ba3d-bbb6e8238ef9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8979-7059-b680-096ec84cd80e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace, comfortable seating, and large windows.",
        "public_id": "019fb452-8979-7059-b680-096ec84cd80e",
        "storage_key": "property/6767906449167041/019fb452-8979-7059-b680-096ec84cd80e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring a cozy fireplace, ample seating, and bright, open spaces.",
      "link": "",
      "alt_text": "Modern lounge area with a fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-69e8-71f9-8e38-85ac0474dfec.webp"
    },
    {
      "id": "custom_d71bc3e3-976a-40fb-a0c7-02dd895cfab2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8a9e-7127-993c-c74455b607fa.webp",
      "image_media": {
        "alt_text": "Spacious modern community lounge with fireplace, large clock, and comfortable seating.",
        "public_id": "019fb452-8a9e-7127-993c-c74455b607fa",
        "storage_key": "property/6767906449167041/019fb452-8a9e-7127-993c-c74455b607fa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring a cozy fireplace, elegant decor, and ample seating for residents to enjoy.",
      "link": "",
      "alt_text": "Spacious modern community lounge with fireplace, large clock, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7eeb-733c-85f8-d3b54c17af44.webp"
    },
    {
      "id": "custom_08b644d8-7064-457c-bcd0-c5531144352b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8c69-74da-a5e7-01b32378d24e.webp",
      "image_media": {
        "alt_text": "Kitchenette with dark cabinets, stainless steel appliances, and a large wall clock.",
        "public_id": "019fb452-8c69-74da-a5e7-01b32378d24e",
        "storage_key": "property/6767906449167041/019fb452-8c69-74da-a5e7-01b32378d24e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A stylish kitchenette area featuring dark cabinetry, a stainless steel refrigerator, dishwasher, and microwave, complemented by a decorative brick wall and a large clock.",
      "link": "",
      "alt_text": "Kitchenette with dark cabinets, stainless steel appliances, and a large wall clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-9dc6-734e-aa5e-9b705f6d489f.webp"
    },
    {
      "id": "custom_976b17b1-18e8-4b20-b19a-e8174690b4a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-94f8-76a3-ad1f-327f5daf55fe.webp",
      "image_media": {
        "alt_text": "Communal lounge with a fireplace, wall-mounted TV, and green seating.",
        "public_id": "019fb452-94f8-76a3-ad1f-327f5daf55fe",
        "storage_key": "property/6767906449167041/019fb452-94f8-76a3-ad1f-327f5daf55fe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A modern leasing lounge featuring a gas fireplace, mounted TV, and plush seating in a welcoming community space.",
      "link": "",
      "alt_text": "Communal lounge with a fireplace, wall-mounted TV, and green seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c384-75ee-96df-94ea48ccd311.webp"
    },
    {
      "id": "custom_32baa4f5-67c4-4f75-a111-ff7c3a356050",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-94b4-7189-8899-377a264c2bd2.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with large windows, a reception table, seating, and a wall-mounted TV.",
        "public_id": "019fb452-94b4-7189-8899-377a264c2bd2",
        "storage_key": "property/6767906449167041/019fb452-94b4-7189-8899-377a264c2bd2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stylish on-site community lounge with reception desk, seating areas, and contemporary amenities for residents.",
      "link": "",
      "alt_text": "Modern apartment community lounge with large windows, a reception table, seating, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c375-74a1-bdfd-9ebfe724ceca.webp"
    },
    {
      "id": "custom_071c4723-1a73-4a5f-a6fc-56179f55473d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-9640-7566-8c10-aeb434ee25d8.webp",
      "image_media": {
        "alt_text": "Modern apartment community lobby with seating, a reception desk, and large windows.",
        "public_id": "019fb452-9640-7566-8c10-aeb434ee25d8",
        "storage_key": "property/6767906449167041/019fb452-9640-7566-8c10-aeb434ee25d8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Interior of a modern apartment community lobby featuring seating areas, a reception desk, and expansive windows.",
      "link": "",
      "alt_text": "Modern apartment community lobby with seating, a reception desk, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c373-77fb-84a1-cbb6ccfa6848.webp"
    },
    {
      "id": "custom_0bf631aa-db1c-4e70-a5e1-d500c9ffdc39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-968f-7487-8928-e26e86f047a2.webp",
      "image_media": {
        "alt_text": "Bright community lobby with beige sofa, green chairs, a fireplace, and large windows.",
        "public_id": "019fb452-968f-7487-8928-e26e86f047a2",
        "storage_key": "property/6767906449167041/019fb452-968f-7487-8928-e26e86f047a2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern apartment community lobby with comfortable seating, a contemporary fireplace, and large windows for natural light.",
      "link": "",
      "alt_text": "Bright community lobby with beige sofa, green chairs, a fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c385-71e8-9a70-fb39b792cb40.webp"
    },
    {
      "id": "custom_7cb60be8-69ba-44d3-87fb-192ce025564c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-9fb9-72c3-8675-b11962c768bc.webp",
      "image_media": {
        "alt_text": "Open-concept apartment kitchen with stainless fridge, dark cabinets, and a red mural on a white brick wall.",
        "public_id": "019fb452-9fb9-72c3-8675-b11962c768bc",
        "storage_key": "property/6767906449167041/019fb452-9fb9-72c3-8675-b11962c768bc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern apartment kitchen with stainless appliances, dark cabinetry, and a decorative mural.",
      "link": "",
      "alt_text": "Open-concept apartment kitchen with stainless fridge, dark cabinets, and a red mural on a white brick wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c377-7741-8851-346135795a26.webp"
    },
    {
      "id": "custom_530c239f-cb7b-4a76-b082-fb72da552db9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-a112-748b-80c1-62e4ffa8f5cd.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
        "public_id": "019fb452-a112-748b-80c1-62e4ffa8f5cd",
        "storage_key": "property/6767906449167041/019fb452-a112-748b-80c1-62e4ffa8f5cd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a variety of cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-69a7-74b7-be5f-7d30b6fc7fa0.webp"
    },
    {
      "id": "custom_20f5a1fa-26b9-46d0-b703-589c1f47ab66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-a0c4-758d-901a-749f276bc453.webp",
      "image_media": {
        "alt_text": "Modern apartment community gym with treadmills, weight machines, and large windows.",
        "public_id": "019fb452-a0c4-758d-901a-749f276bc453",
        "storage_key": "property/6767906449167041/019fb452-a0c4-758d-901a-749f276bc453.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright on-site fitness center for residents with cardio and strength equipment.",
      "link": "",
      "alt_text": "Modern apartment community gym with treadmills, weight machines, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-c3a3-765a-9038-c7dbcb48f196.webp"
    },
    {
      "id": "custom_04e36940-70ba-4bf4-9c03-d02c25808fe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-a48f-703c-9271-a02cebf26f06.webp",
      "image_media": {
        "alt_text": "Dog bed and feeding station with wall art and an electrical panel.",
        "public_id": "019fb452-a48f-703c-9271-a02cebf26f06",
        "storage_key": "property/6767906449167041/019fb452-a48f-703c-9271-a02cebf26f06.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Community",
      "description": "Create a comfortable space for your furry friend with a dedicated dog bed, feeding station, and charming wall art, all while keeping utilities organized with a discreet electrical panel.",
      "link": "",
      "alt_text": "Dog bed and feeding station with wall art and an electrical panel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5d87-7700-adb0-fdfaf2cce048.webp"
    },
    {
      "id": "custom_5c9dc147-a0cf-42b5-9c17-d15d538ad53e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-aafb-744c-b2ad-b8cee6338c8b.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table and four chairs, next to a desk and window.",
        "public_id": "019fb452-aafb-744c-b2ad-b8cee6338c8b",
        "storage_key": "property/6767906449167041/019fb452-aafb-744c-b2ad-b8cee6338c8b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals and conversations in this elegant dining area, featuring a stylish glass-top table and comfortable seating, perfectly complemented by a convenient desk and natural light from the large window.",
      "link": "",
      "alt_text": "Dining area with a glass-top table and four chairs, next to a desk and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5fb6-705b-9828-51920d34c44b.webp"
    },
    {
      "id": "custom_73334d42-77d1-4dc5-a774-14de0818c06b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-aeff-7716-a1df-9a368794f269.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual vanities, a toilet, and a bathtub with a shower curtain.",
        "public_id": "019fb452-aeff-7716-a1df-9a368794f269",
        "storage_key": "property/6767906449167041/019fb452-aeff-7716-a1df-9a368794f269.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring elegant dark wood cabinetry, a granite countertop with dual sinks, and a bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with dual vanities, a toilet, and a bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5d74-723e-800f-ce0cd871666a.webp"
    },
    {
      "id": "custom_67862f2f-8c14-4d05-b59e-2613cea9e9eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-b015-71bf-be8b-1d6d607cde54.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fb452-b015-71bf-be8b-1d6d607cde54",
        "storage_key": "property/6767906449167041/019fb452-b015-71bf-be8b-1d6d607cde54.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed bathroom featuring a spacious vanity, a modern toilet, and a bathtub with a stylish shower curtain, perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5add-72fe-a8f0-22c72bcd4709.webp"
    },
    {
      "id": "custom_917a9d6f-38eb-4542-a380-291bac80a63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-b016-77e4-97b4-3b73321f28df.webp",
      "image_media": {
        "alt_text": "Dining area with a marble-top table and four upholstered chairs, large windows with blinds.",
        "public_id": "019fb452-b016-77e4-97b4-3b73321f28df",
        "storage_key": "property/6767906449167041/019fb452-b016-77e4-97b4-3b73321f28df.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a stylish marble-top table and comfortable seating, perfect for family dinners or entertaining guests.",
      "link": "",
      "alt_text": "Dining area with a marble-top table and four upholstered chairs, large windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5bf2-74c9-853e-d86f529acd74.webp"
    },
    {
      "id": "custom_7a313f6f-ad16-4581-8150-a2fd6cdb186a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-b737-726d-9ffe-bd9d4fa48054.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large wooden bed, bedside tables, and a ceiling fan.",
        "public_id": "019fb452-b737-726d-9ffe-bd9d4fa48054",
        "storage_key": "property/6767906449167041/019fb452-b737-726d-9ffe-bd9d4fa48054.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant bedside tables, and a refreshing ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Cozy bedroom with a large wooden bed, bedside tables, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-594c-74fe-a27a-0187992e4e7a.webp"
    },
    {
      "id": "custom_803999e5-92a7-4911-9879-91d96c8eacd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-b9bb-724c-835b-b4bff8a7c383.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with island seating",
        "public_id": "019fb452-b9bb-724c-835b-b4bff8a7c383",
        "storage_key": "property/6767906449167041/019fb452-b9bb-724c-835b-b4bff8a7c383.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a modern kitchen with ample counter space and bar seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with island seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-5bee-736b-a457-aed302b00055.webp"
    },
    {
      "id": "custom_1c569119-4ca6-40eb-8f06-85c50846500f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-baa7-752c-ab4c-92e74dd60b53.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table, four upholstered chairs, and decorative items.",
        "public_id": "019fb452-baa7-752c-ab4c-92e74dd60b53",
        "storage_key": "property/6767906449167041/019fb452-baa7-752c-ab4c-92e74dd60b53.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a glass-top table with four upholstered chairs, perfect for intimate meals. This space is enhanced by decorative accents and a large statement mirror.",
      "link": "",
      "alt_text": "Dining area with a glass-top table, four upholstered chairs, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-694f-7488-b8eb-8204fd00ce7d.webp"
    },
    {
      "id": "custom_3c7f7ea0-47c7-48d2-a49a-d22050d6968f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-bb7e-7596-9359-667ab0075daa.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and stacked boxes",
        "public_id": "019fb452-bb7e-7596-9359-667ab0075daa",
        "storage_key": "property/6767906449167041/019fb452-bb7e-7596-9359-667ab0075daa.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and carpeted floors, perfect for all your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and stacked boxes",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-69be-7097-8a24-86aefabc6bef.webp"
    },
    {
      "id": "custom_aba6450d-4de7-40a3-8e94-aafeb5edaa85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-c2c5-75aa-b499-7cc3045ebe46.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb452-c2c5-75aa-b499-7cc3045ebe46",
        "storage_key": "property/6767906449167041/019fb452-c2c5-75aa-b499-7cc3045ebe46.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinetry, sleek granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-69a9-700b-ba7b-d8ca329457b8.webp"
    },
    {
      "id": "custom_c3b94686-ecdd-48b0-b2b7-cface59e32f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-c41f-721f-bdfd-dbe89faf299d.webp",
      "image_media": {
        "alt_text": "A stylish desk area with a chair and a dining area with a table and chairs in an apartment.",
        "public_id": "019fb452-c41f-721f-bdfd-dbe89faf299d",
        "storage_key": "property/6767906449167041/019fb452-c41f-721f-bdfd-dbe89faf299d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Create your ideal workspace or enjoy a meal in this versatile dining and desk area, featuring elegant furnishings and ample natural light.",
      "link": "",
      "alt_text": "A stylish desk area with a chair and a dining area with a table and chairs in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-6ce3-71cc-bef4-b2e294892d30.webp"
    },
    {
      "id": "custom_819ee72b-45ae-4a2b-8783-29f6aae4678d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-c455-72cd-9145-dddd27056766.webp",
      "image_media": {
        "alt_text": "Living room with a couch, armchair, coffee table, and TV stand.",
        "public_id": "019fb452-c455-72cd-9145-dddd27056766",
        "storage_key": "property/6767906449167041/019fb452-c455-72cd-9145-dddd27056766.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush couch, accent armchair, elegant coffee table, and a stylish TV stand with ample storage.",
      "link": "",
      "alt_text": "Living room with a couch, armchair, coffee table, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-724c-719a-a09c-7311174fb3ba.webp"
    },
    {
      "id": "custom_0bf4226c-f691-41a8-9e9b-3869e7d129e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-c79e-72c8-8ab9-4b58bb8f3f02.webp",
      "image_media": {
        "alt_text": "Living room and dining area with furniture.",
        "public_id": "019fb452-c79e-72c8-8ab9-4b58bb8f3f02",
        "storage_key": "property/6767906449167041/019fb452-c79e-72c8-8ab9-4b58bb8f3f02.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and a table.",
      "link": "",
      "alt_text": "Living room and dining area with furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-748f-713a-8f72-1e5cc0883acf.webp"
    },
    {
      "id": "custom_a245d416-4bf8-4e85-93e3-53635ed5e745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ce02-75fa-8a2e-7a9bdd2383b1.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fb452-ce02-75fa-8a2e-7a9bdd2383b1",
        "storage_key": "property/6767906449167041/019fb452-ce02-75fa-8a2e-7a9bdd2383b1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite-top vanity, toilet, and bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7b35-721e-a7f2-de4623f835ad.webp"
    },
    {
      "id": "custom_58bdbb6d-eb85-451e-9d91-bc0298dc5e89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-cfe9-7065-a614-a77e007cb970.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, nightstand, and decorative wall art.",
        "public_id": "019fb452-cfe9-7065-a614-a77e007cb970",
        "storage_key": "property/6767906449167041/019fb452-cfe9-7065-a614-a77e007cb970.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and elegant decor.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, nightstand, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7c75-725c-a4e3-d18abadcd007.webp"
    },
    {
      "id": "custom_3c5fb78e-cd33-4c1c-a824-17982fdd8b5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-cf86-772a-8af9-e0fd3d487499.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, neutral-toned decor, and a ceiling fan.",
        "public_id": "019fb452-cf86-772a-8af9-e0fd3d487499",
        "storage_key": "property/6767906449167041/019fb452-cf86-772a-8af9-e0fd3d487499.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a queen-size bed with stylish bedding and ample natural light from the large windows.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-size bed, neutral-toned decor, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7c45-773f-b36d-e0437e5d3717.webp"
    },
    {
      "id": "custom_84298778-378c-4cca-9c64-2a5aef34fc15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d44d-72b8-91c1-73e3ca893803.webp",
      "image_media": {
        "alt_text": "Living and dining area with sofa, chairs, and dining table.",
        "public_id": "019fb452-d44d-72b8-91c1-73e3ca893803",
        "storage_key": "property/6767906449167041/019fb452-d44d-72b8-91c1-73e3ca893803.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, elegant accent chairs, and a dining table set for meals.",
      "link": "",
      "alt_text": "Living and dining area with sofa, chairs, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7eeb-733c-85f8-cd468b3fbeb0.webp"
    },
    {
      "id": "custom_e3a7c686-2c74-4895-967e-49c9b2b5de20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, and dining area",
        "public_id": "019fb452-d9fb-72a6-8ad2-800c612b5c3a",
        "storage_key": "property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, comfortable sofa, and a dedicated dining space. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, and dining area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-7e84-74b9-a958-c4ec378cf45f.webp"
    },
    {
      "id": "custom_da38a85c-2ac2-4d62-808f-f352e2e9335d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-da35-71d2-93e0-b1788d057fdf.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, coffee table, and kitchen counter with bar stools.",
        "public_id": "019fb452-da35-71d2-93e0-b1788d057fdf",
        "storage_key": "property/6767906449167041/019fb452-da35-71d2-93e0-b1788d057fdf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable leather sofa, modern coffee table, and a breakfast bar with bar stools, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a leather sofa, coffee table, and kitchen counter with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-80c7-7482-8c37-ec02ca041c85.webp"
    },
    {
      "id": "custom_192709b5-6ac6-4cba-a2b4-76abf2497e54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-da8e-7295-a7a4-f39feff58b03.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, decorative wall hangings, and a ceiling fan.",
        "public_id": "019fb452-da8e-7295-a7a4-f39feff58b03",
        "storage_key": "property/6767906449167041/019fb452-da8e-7295-a7a4-f39feff58b03.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, stylish wall decor, and a ceiling fan for added comfort. Large windows allow natural light to fill the room.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, decorative wall hangings, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-8541-76cc-8105-e6d3b975f608.webp"
    },
    {
      "id": "custom_4c9bdaa8-eaa1-42bb-9fb9-5fd1da649e4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-de34-77a8-b76e-f9c30a9ef32b.webp",
      "image_media": {
        "alt_text": "Vanity desk and chair in a room with large windows.",
        "public_id": "019fb452-de34-77a8-b76e-f9c30a9ef32b",
        "storage_key": "property/6767906449167041/019fb452-de34-77a8-b76e-f9c30a9ef32b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Create your personal oasis in this charming vanity area, perfect for getting ready for your day.",
      "link": "",
      "alt_text": "Vanity desk and chair in a room with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-8a53-76b9-bdce-ea19290e79a3.webp"
    },
    {
      "id": "custom_4fe66de7-89c7-4b71-9298-9f9ca9348081",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-e462-745e-bd15-65b8abb1d1e3.webp",
      "image_media": {
        "alt_text": "In-unit laundry area with washer, dryer, and hamper.",
        "public_id": "019fb452-e462-745e-bd15-65b8abb1d1e3",
        "storage_key": "property/6767906449167041/019fb452-e462-745e-bd15-65b8abb1d1e3.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities with washer, dryer, and a decorative hamper for a clean and fresh living space.",
      "link": "",
      "alt_text": "In-unit laundry area with washer, dryer, and hamper.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-8def-71eb-8407-7325999b26b3.webp"
    },
    {
      "id": "custom_d5a71f5b-e3fa-40c3-890a-4303157b7d4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-e53a-708b-9b11-857bad6381f3.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and chairs, featuring a decorative wall display and a door leading outside.",
        "public_id": "019fb452-e53a-708b-9b11-857bad6381f3",
        "storage_key": "property/6767906449167041/019fb452-e53a-708b-9b11-857bad6381f3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish dining area with a wooden table and upholstered chairs, accented by unique wall decor and access to an outdoor space. Perfect for enjoying meals and entertaining.",
      "link": "",
      "alt_text": "Dining area with a wooden table and chairs, featuring a decorative wall display and a door leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-8ea9-7378-a110-648396c65c35.webp"
    },
    {
      "id": "custom_b09d7b5e-e26f-4069-8867-88427c7116f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-e4ca-71cf-9f8f-65abd1529e7b.webp",
      "image_media": {
        "alt_text": "A king size bed in a bedroom with bedside tables and lamps.",
        "public_id": "019fb452-e4ca-71cf-9f8f-65abd1529e7b",
        "storage_key": "property/6767906449167041/019fb452-e4ca-71cf-9f8f-65abd1529e7b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king size bed, plush carpeting, and ample closet space. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "A king size bed in a bedroom with bedside tables and lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-92e9-7196-a662-8996b5bdb98e.webp"
    },
    {
      "id": "custom_f4b6ac6f-dada-4966-b9fa-41bc0a303c77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-e89e-70d7-abbd-af9081d5e45f.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, and seating.",
        "public_id": "019fb452-e89e-70d7-abbd-af9081d5e45f",
        "storage_key": "property/6767906449167041/019fb452-e89e-70d7-abbd-af9081d5e45f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and comfortable seating, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-934c-709b-bef4-7a9a2ab3345f.webp"
    },
    {
      "id": "custom_0470891b-8638-45d2-94b9-ad3511a3401d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and wood-look tile flooring.",
        "public_id": "019fb452-ee3f-7319-9904-d36058038051",
        "storage_key": "property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Experience effortless meal prep and elegant dining in this beautifully appointed kitchen, featuring ample cabinet space and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and wood-look tile flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-97af-720a-9e13-c7ee641ea056.webp"
    },
    {
      "id": "custom_1c52c406-206b-488e-be0b-0508d942ef28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f088-754f-83ea-f87b4d3e47ab.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, granite countertop, and a walk-in shower.",
        "public_id": "019fb452-f088-754f-83ea-f87b4d3e47ab",
        "storage_key": "property/6767906449167041/019fb452-f088-754f-83ea-f87b4d3e47ab.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a dual vanity with ample storage, a granite countertop, and a beautifully tiled walk-in shower with a curtain. Perfect for relaxation and convenience.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, granite countertop, and a walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-9aef-7295-9bc9-84b6ab900cf2.webp"
    },
    {
      "id": "custom_2a720f3e-6141-4a45-a8a1-e3574da1f88b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-efe8-721b-89f6-802e9b058297.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
        "public_id": "019fb452-efe8-721b-89f6-802e9b058297",
        "storage_key": "property/6767906449167041/019fb452-efe8-721b-89f6-802e9b058297.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this beautifully appointed kitchen, featuring dark wood cabinetry, granite countertops, and a full suite of stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-9ad1-712f-a615-6620e7fdf87c.webp"
    },
    {
      "id": "custom_9ccfb82e-ca87-4737-aaf2-7f17ffc00dba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, ceiling fan, and window.",
        "public_id": "019fb452-f29a-73e1-89db-6426a7dac986",
        "storage_key": "property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a queen-size bed, matching nightstands, a dresser, and a ceiling fan for comfort. The room is well-lit by natural light from the window.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, dresser, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-9b35-76aa-ab6f-ca349c6383cf.webp"
    },
    {
      "id": "custom_7a4e5697-3453-4ffd-ad7d-52e748c7b745",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f94c-7154-8ada-9c149044d8aa.webp",
      "image_media": {
        "alt_text": "Kitchen with dark brown cabinets, granite countertops, stainless steel appliances, and a white refrigerator.",
        "public_id": "019fb452-f94c-7154-8ada-9c149044d8aa",
        "storage_key": "property/6767906449167041/019fb452-f94c-7154-8ada-9c149044d8aa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark brown cabinetry, granite countertops, stainless steel appliances including a microwave and refrigerator, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Kitchen with dark brown cabinets, granite countertops, stainless steel appliances, and a white refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-a21e-75b9-830f-64ed31ec217f.webp"
    },
    {
      "id": "custom_827099e6-a049-4a69-bf93-f67a9250dba9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f931-703b-abc7-6d7f616b69fb.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fb452-f931-703b-abc7-6d7f616b69fb",
        "storage_key": "property/6767906449167041/019fb452-f931-703b-abc7-6d7f616b69fb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Enjoy a spacious bathroom featuring a modern vanity, a convenient toilet, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-a2ff-77cb-a0a7-4bd481e6347a.webp"
    },
    {
      "id": "custom_5914658a-af3c-471b-aaa7-d8d2becd982d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-fadf-7496-b8a4-7c637fb31c65.webp",
      "image_media": {
        "alt_text": "Open-concept in-unit kitchen with granite island, dark cabinets, and stainless-steel appliances.",
        "public_id": "019fb452-fadf-7496-b8a4-7c637fb31c65",
        "storage_key": "property/6767906449167041/019fb452-fadf-7496-b8a4-7c637fb31c65.webp",
        "width": 788,
        "height": 526
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with an island, granite countertops, and stainless-steel fridge.",
      "link": "",
      "alt_text": "Open-concept in-unit kitchen with granite island, dark cabinets, and stainless-steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-d6c2-769d-9719-d74dbf8122d1.webp"
    },
    {
      "id": "custom_0daa2b89-7399-4b22-843b-ec1f07f0d05c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-fcf3-710b-a920-d58df930bd54.webp",
      "image_media": {
        "alt_text": "Dining area with glass table and beige chairs by large windows.",
        "public_id": "019fb452-fcf3-710b-a920-d58df930bd54",
        "storage_key": "property/6767906449167041/019fb452-fcf3-710b-a920-d58df930bd54.webp",
        "width": 776,
        "height": 518
      },
      "title": "Apartment",
      "description": "Bright apartment dining nook with a glass-top table, beige chairs, and large windows with white curtains.",
      "link": "",
      "alt_text": "Dining area with glass table and beige chairs by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-db71-7631-ac8d-8042a6100175.webp"
    },
    {
      "id": "custom_8b968d01-3021-47d5-95e7-6d992266a1e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-04bf-70dc-8b1f-a5c4ae867261.webp",
      "image_media": {
        "alt_text": "Landscape park area with trees, stone features, and a city skyline in the background.",
        "public_id": "019fb453-04bf-70dc-8b1f-a5c4ae867261",
        "storage_key": "property/6767906449167041/019fb453-04bf-70dc-8b1f-a5c4ae867261.webp",
        "width": 1280,
        "height": 415
      },
      "title": "Lifestyle",
      "description": "Expansive outdoor community space with lawns, trees, stone walls, and winding paths against a city skyline.",
      "link": "",
      "alt_text": "Landscape park area with trees, stone features, and a city skyline in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-d293-7358-bd58-e17d6ba30e1f.webp"
    },
    {
      "id": "custom_928d7ce3-70c4-49d4-b738-bbdc54421a2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-03a1-76d3-af43-88e1276c5ca7.webp",
      "image_media": {
        "alt_text": "Person holding a white insulated cup beside a bicycle handlebar.",
        "public_id": "019fb453-03a1-76d3-af43-88e1276c5ca7",
        "storage_key": "property/6767906449167041/019fb453-03a1-76d3-af43-88e1276c5ca7.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image showing a person with a tumbler beside a bicycle, suggesting active outdoor living.",
      "link": "",
      "alt_text": "Person holding a white insulated cup beside a bicycle handlebar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-dc55-769a-af75-cc42ee8a1f03.webp"
    },
    {
      "id": "custom_b25d4373-df93-461c-924f-502fab0dd238",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-0516-706f-8ac1-0f0b27104453.webp",
      "image_media": {
        "alt_text": "Children with backpacks lining up to board a yellow school bus.",
        "public_id": "019fb453-0516-706f-8ac1-0f0b27104453",
        "storage_key": "property/6767906449167041/019fb453-0516-706f-8ac1-0f0b27104453.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "A lifestyle image of kids with backpacks boarding a yellow school bus, suggesting a family-friendly community.",
      "link": "",
      "alt_text": "Children with backpacks lining up to board a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-dc92-7059-9c2d-94f170b5a2fd.webp"
    },
    {
      "id": "custom_0d52e977-74bb-45d0-9fbe-3c9aaae32f24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-0711-75dd-be77-43458a372e73.webp",
      "image_media": {
        "alt_text": "Group of friends bowling together in the property's recreation center.",
        "public_id": "019fb453-0711-75dd-be77-43458a372e73",
        "storage_key": "property/6767906449167041/019fb453-0711-75dd-be77-43458a372e73.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Lifestyle",
      "description": "Residents have a fun bowling night in the property's community recreation area.",
      "link": "",
      "alt_text": "Group of friends bowling together in the property's recreation center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-dcbb-774c-a6b1-da13025497e3.webp"
    },
    {
      "id": "custom_4f3fc7e1-8a4f-4d45-9602-74bdc5d8ba80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-0d42-7490-b434-216ac6c7f243.webp",
      "image_media": {
        "alt_text": "People seated in a movie theater with red seats, laughing and sharing popcorn.",
        "public_id": "019fb453-0d42-7490-b434-216ac6c7f243",
        "storage_key": "property/6767906449167041/019fb453-0d42-7490-b434-216ac6c7f243.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Lifestyle",
      "description": "Lifestyle photo of residents enjoying a movie night in a red-upholstered theater, showcasing community amenities.",
      "link": "",
      "alt_text": "People seated in a movie theater with red seats, laughing and sharing popcorn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-e1bb-71f9-9c75-611deb329e23.webp"
    },
    {
      "id": "custom_b0cf83e1-ef07-432d-9db5-38592de5f138",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-0e99-770d-aaef-33c6511efc82.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment community with storefronts, planters, and shoppers.",
        "public_id": "019fb453-0e99-770d-aaef-33c6511efc82",
        "storage_key": "property/6767906449167041/019fb453-0e99-770d-aaef-33c6511efc82.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "A pedestrian-friendly exterior of the apartment community featuring retail shops, wide walkways, and landscaping.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment community with storefronts, planters, and shoppers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167041/019cfb51-dcdb-71ec-81f7-52deb52d31d8.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4f12bc2a-2930-4029-a036-e9345feb4167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tasty steaks, ribs, and fried pickles, and the rolls are delicious. They also highlight the affordable prices, lively atmosphere, and attentive service.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-0ee3-7011-8003-7cbfc954616a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0ee3-7011-8003-7cbfc954616a",
        "storage_key": "property/6767906449167041/019d270e-0ee3-7011-8003-7cbfc954616a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4176-768d-b3ec-09f3ec3cc28a",
        "storage_key": "property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ec3eb3b9-734c-4a56-9196-7306fe607e13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "People say this restaurant serves delicious croissants, steak, and salmon. They also highlight the reasonable prices, generous portions, and friendly service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-0e60-71e3-99cc-7e30a0ee0aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0e60-71e3-99cc-7e30a0ee0aee",
        "storage_key": "property/6767906449167041/019d270e-0e60-71e3-99cc-7e30a0ee0aee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4176-768d-b3ec-09f3ec3cc28a",
        "storage_key": "property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6dbd3045-c22f-4a05-9a00-9ef985b4b5d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1100 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves crispy chicken fingers, Texas toast, and fries. They highlight the tasty dipping sauce and the fresh, hot food. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-0f3b-7738-a28c-238aa4592348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0f3b-7738-a28c-238aa4592348",
        "storage_key": "property/6767906449167041/019d270e-0f3b-7738-a28c-238aa4592348.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/broken-arrow/1100-n.-9th-st.",
      "poi_directions_map_url": "https://maps.google.com/?cid=6389543638470134900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0621208",
      "poi_longitude": "-95.7802036",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-259-0213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4176-768d-b3ec-09f3ec3cc28a",
        "storage_key": "property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT-hA7eLtocRdIze_xU4rFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_685187c0-e25b-4b75-8297-324f217c3f6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Savastano’s",
      "poi_type": "Restaurants",
      "poi_address": "8211 E Regal Pl Suite 109, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual eatery dishing Chicago-style pizzas plus American classics & salad-bar fare.",
      "poi_long_description": "People say this pizza restaurant serves fantastic deep dish pizza, as well as regular crust pizza, fried ravioli, and garlic cheese bread. They highlight the generous portions, reasonable prices, and fun, laid-back atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-0e8a-72a8-9dfa-1a604b437865.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-0e8a-72a8-9dfa-1a604b437865",
        "storage_key": "property/6767906449167041/019d270e-0e8a-72a8-9dfa-1a604b437865.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savastanospizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13218962470008677414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "savastanos",
      "poi_latitude": "36.0112009",
      "poi_longitude": "-95.8836538",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-369-9387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4176-768d-b3ec-09f3ec3cc28a",
        "storage_key": "property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zkSGxaOtocRJmQWVFQwc7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_bee908db-8c4b-4d24-acb0-3d4216b98081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11201 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers a large, fresh Southwest Salad with grilled chicken and a tasty Creamy Salsa dressing. They highlight the salad is a great low-carb choice. They also like the fast service, especially during lunch rush, and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-12ea-773c-9b75-0a2c2f9888f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-12ea-773c-9b75-0a2c2f9888f9",
        "storage_key": "property/6767906449167041/019d270e-12ea-773c-9b75-0a2c2f9888f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/eastside-market?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13877322036504863520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.061357",
      "poi_longitude": "-95.852101",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-461-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4176-768d-b3ec-09f3ec3cc28a",
        "storage_key": "property/6767906449167041/019d270e-4176-768d-b3ec-09f3ec3cc28a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE_NPDkyMtocRIKOS890mlsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ef8b5b56-8848-40c0-b144-7b9e6acc9c81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-138d-729c-ad1a-af447e82f7f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-138d-729c-ad1a-af447e82f7f7",
        "storage_key": "property/6767906449167041/019d270e-138d-729c-ad1a-af447e82f7f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-414e-77aa-b262-ac45fa25b9fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-414e-77aa-b262-ac45fa25b9fd",
        "storage_key": "property/6767906449167041/019d270e-414e-77aa-b262-ac45fa25b9fd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_846cab6b-d2f2-49ac-85b1-9eae98700ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-131e-707a-a806-52d99496ce5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-131e-707a-a806-52d99496ce5f",
        "storage_key": "property/6767906449167041/019d270e-131e-707a-a806-52d99496ce5f.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0598878",
      "poi_longitude": "-95.8665158",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-41e3-76ce-8ffa-4f1e42e2f023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-41e3-76ce-8ffa-4f1e42e2f023",
        "storage_key": "property/6767906449167041/019d270e-41e3-76ce-8ffa-4f1e42e2f023.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_55f29393-8dc4-44d3-994e-7c0d23e02bdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "11114 S Memorial Dr, Bixby, OK 74008, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a wide selection of items and a helpful pro desk. They also highlight the friendly and knowledgeable staff, and the convenient parking.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-13df-72e0-8df3-fa831cfdd672.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-13df-72e0-8df3-fa831cfdd672",
        "storage_key": "property/6767906449167041/019d270e-13df-72e0-8df3-fa831cfdd672.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Bixby/1532?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1532-_-na-_-0-_-0&y_source=1_MTE4NDQwMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15185551513414272469&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.0017",
      "poi_longitude": "-95.8873",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-369-8844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-41e3-76ce-8ffa-4f1e42e2f023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-41e3-76ce-8ffa-4f1e42e2f023",
        "storage_key": "property/6767906449167041/019d270e-41e3-76ce-8ffa-4f1e42e2f023.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP7cWIiWOtocR1QV0G6XqvdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4996c7fc-fb8c-4f41-b75c-25f40c6d6cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-1840-7241-adb0-485005769cf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1840-7241-adb0-485005769cf5",
        "storage_key": "property/6767906449167041/019d270e-1840-7241-adb0-485005769cf5.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-414e-77aa-b262-ab621c8e3435",
        "storage_key": "property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_89bd0cb6-e9de-471e-8d10-2958f8c95444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-17c3-7383-8747-fa826879cf13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-17c3-7383-8747-fa826879cf13",
        "storage_key": "property/6767906449167041/019d270e-17c3-7383-8747-fa826879cf13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019379",
      "poi_longitude": "-95.748523",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-414e-77aa-b262-ab621c8e3435",
        "storage_key": "property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f5489d96-1fc3-4f67-81bb-c7cddaa96d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide variety of books and engaging programs for all ages, including story time for infants and toddlers. They highlight the spacious and beautiful environment, with comfortable seating and study rooms, and the helpful staff. They also like the dedicated kids' area with board books and activities, and the clean bathrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-17e2-737e-93a6-dc84fe131700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-17e2-737e-93a6-dc84fe131700",
        "storage_key": "property/6767906449167041/019d270e-17e2-737e-93a6-dc84fe131700.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-414e-77aa-b262-ab621c8e3435",
        "storage_key": "property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c05025b5-e75b-4e12-84c1-556c2ee450d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-196b-705b-af20-3f0d49c9bbfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-196b-705b-af20-3f0d49c9bbfa",
        "storage_key": "property/6767906449167041/019d270e-196b-705b-af20-3f0d49c9bbfa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-452c-766b-b3a4-4f38aa4b887a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-452c-766b-b3a4-4f38aa4b887a",
        "storage_key": "property/6767906449167041/019d270e-452c-766b-b3a4-4f38aa4b887a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3927d1bb-3102-43d8-ba16-24224cfc6153",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Broken Arrow Library",
      "poi_type": "Education",
      "poi_address": "300 W Broadway Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed spot featuring summer reading programs, plus helpful staff and books.",
      "poi_long_description": "People say this public library has helpful staff who can assist with checking out books, placing holds, and finding sister locations, as well as apps for readers and a pamphlet of activities and new releases. They also highlight the library's clean and cozy atmosphere with plenty of spots to sit and work or read.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-1d9f-76ff-9200-6c6c0ecebf25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1d9f-76ff-9200-6c6c0ecebf25",
        "storage_key": "property/6767906449167041/019d270e-1d9f-76ff-9200-6c6c0ecebf25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsalibrary.org/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472699381773494596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broken-arrow-library",
      "poi_latitude": "36.0529865",
      "poi_longitude": "-95.7936926",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-414e-77aa-b262-ab621c8e3435",
        "storage_key": "property/6767906449167041/019d270e-414e-77aa-b262-ab621c8e3435.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxNF-OmLtocRROkP2pmAVpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_bae25c1d-cf37-490a-ae57-0cbbe3ea81fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Tiger Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-1d25-74cc-a43b-8008c890317d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1d25-74cc-a43b-8008c890317d",
        "storage_key": "property/6767906449167041/019d270e-1d25-74cc-a43b-8008c890317d.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "https://batigersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374532252761582339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiger-memorial-stadium",
      "poi_latitude": "36.0743308",
      "poi_longitude": "-95.7632923",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-259-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45a4-76d3-97c9-2d9e4e46fb29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45a4-76d3-97c9-2d9e4e46fb29",
        "storage_key": "property/6767906449167041/019d270e-45a4-76d3-97c9-2d9e4e46fb29.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SOplVCKtocRA-sfZ0_jdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_6e8dec96-ad24-4622-91ba-848bd5b74c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-1dd8-774b-8db3-8fcab81cf1cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1dd8-774b-8db3-8fcab81cf1cc",
        "storage_key": "property/6767906449167041/019d270e-1dd8-774b-8db3-8fcab81cf1cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4562-76c1-92f1-f94960dc3188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4562-76c1-92f1-f94960dc3188",
        "storage_key": "property/6767906449167041/019d270e-4562-76c1-92f1-f94960dc3188.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3aef024a-c4c3-4841-befb-8c5b45e256e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Rose District Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "416 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Popular destination featuring a fountain and splash pad where kids can play in the water and adults can relax.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-1fbe-74c6-b259-ee23cd1a83a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1fbe-74c6-b259-ee23cd1a83a2",
        "storage_key": "property/6767906449167041/019d270e-1fbe-74c6-b259-ee23cd1a83a2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://rosedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7184917167890550428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-district-splash-pad",
      "poi_latitude": "36.0488437",
      "poi_longitude": "-95.7910116",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0CU3cKLtocRnM64zBj0tWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_697fa23a-2878-41e2-8228-d69361a9342c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Military History Museum",
      "poi_type": "Entertainment",
      "poi_address": "112 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Tours and exhibits of military history that feature donated artifacts and memorabilia.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-220a-71c0-9713-86075759486c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-220a-71c0-9713-86075759486c",
        "storage_key": "property/6767906449167041/019d270e-220a-71c0-9713-86075759486c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okmhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208418279094056410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "military-history-museum",
      "poi_latitude": "36.0528999",
      "poi_longitude": "-95.7910559",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-794-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4562-76c1-92f1-f94960dc3188.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4562-76c1-92f1-f94960dc3188",
        "storage_key": "property/6767906449167041/019d270e-4562-76c1-92f1-f94960dc3188.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetKKsKLtocR2nUtknG6Tbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d8f5d75a-1a7a-41fa-86d3-c8f7e6ed8a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Washington Irving’s Camp Historical Marker",
      "poi_type": "Entertainment",
      "poi_address": "13700 S Memorial Dr, Bixby, OK 74008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2335-7438-b538-783d7c55f3aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2335-7438-b538-783d7c55f3aa",
        "storage_key": "property/6767906449167041/019d270e-2335-7438-b538-783d7c55f3aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hmdb.org/m.asp?m=118322",
      "poi_directions_map_url": "https://maps.google.com/?cid=6245404552704427247&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-irvings-camp-historical-marker",
      "poi_latitude": "35.9626151",
      "poi_longitude": "-95.8878566",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-366-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV99lsFCPtocR7wSO4lkirFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_c15dd7fe-9aaf-4397-9c55-185c12230baf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2299-706f-a7dd-24f00b359c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2299-706f-a7dd-24f00b359c4b",
        "storage_key": "property/6767906449167041/019d270e-2299-706f-a7dd-24f00b359c4b.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3c13c542-c386-49f1-b374-6e7164865cee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, a clean facility, and a friendly and helpful staff. They also highlight the spacious layout, the positive and motivating atmosphere, and the great value for the price.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-263d-75da-8deb-1309d5683b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-263d-75da-8deb-1309d5683b45",
        "storage_key": "property/6767906449167041/019d270e-263d-75da-8deb-1309d5683b45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_72c9e2cc-affe-45fc-9996-3835e4a95a11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained equipment, excellent personal trainers, and a great selection of fitness classes.\n\nOther reviews mention the gym can be crowded and management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-27c4-71fa-826d-d382131074b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-27c4-71fa-826d-d382131074b1",
        "storage_key": "property/6767906449167041/019d270e-27c4-71fa-826d-d382131074b1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3c9a1de6-e7c1-4f37-af0b-2b2576e92d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide variety of weight machines, free weights, and cardio equipment, including several Smith machines. They highlight the affordable memberships, convenient location, and clean, well-maintained facility. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-283f-74ae-9504-cb561742edec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-283f-74ae-9504-cb561742edec",
        "storage_key": "property/6767906449167041/019d270e-283f-74ae-9504-cb561742edec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ec19286-994f-4cde-a84e-3211c62e5b7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-28df-75bb-bbe6-ccadfd4e207a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-28df-75bb-bbe6-ccadfd4e207a",
        "storage_key": "property/6767906449167041/019d270e-28df-75bb-bbe6-ccadfd4e207a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c9b362ea-5456-4c19-841b-e7654f316a53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "R.C. Dickenson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Classes, pool and gym with friendly staff plus a variety of exercise machines.",
      "poi_long_description": "People say this gym offers a variety of equipment and is great for workouts. They highlight the youth flag football program and the pool. They also like the family-friendly vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2a73-740c-9d2d-b530d9fa8dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2a73-740c-9d2d-b530d9fa8dac",
        "storage_key": "property/6767906449167041/019d270e-2a73-740c-9d2d-b530d9fa8dac.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcatulsa.org/dickenson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3422791293805268507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rc-dickenson-family-ymca",
      "poi_latitude": "36.0410595",
      "poi_longitude": "-95.8496234",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-872-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0w56y6MtocRGw6QB4wygC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3a382fd1-2e2e-40a3-a979-05d2e4c6e43b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "People say this gym is a beautiful facility with plenty of parking. They highlight the positive learning environment and the impressive, clean space. They also like the large size, suitable for events like cheer championships and technology symposiums.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2cd9-716f-900a-cc747b83023a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2cd9-716f-900a-cc747b83023a",
        "storage_key": "property/6767906449167041/019d270e-2cd9-716f-900a-cc747b83023a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b6529588-8e1a-431c-a814-71738d30a1f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Miami Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "2409 W Kenosha St #161, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2d02-7317-b9a4-238e3ab2ae73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2d02-7317-b9a4-238e3ab2ae73",
        "storage_key": "property/6767906449167041/019d270e-2d02-7317-b9a4-238e3ab2ae73.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://miaminailsbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392555638477026749&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miami-nails",
      "poi_latitude": "36.0596694",
      "poi_longitude": "-95.8197326",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYxGgXSMtocRvfUHv-d7P_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_f4f190cc-b61e-4736-9fc1-eef0a6fbeb6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Lush Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "801 E Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Salon offering manicures, pedicures, waxing, and other nail services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2ed7-72c5-9e12-027714202cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2ed7-72c5-9e12-027714202cde",
        "storage_key": "property/6767906449167041/019d270e-2ed7-72c5-9e12-027714202cde.webp",
        "width": 1280,
        "height": 1232
      },
      "poi_business_url": "https://lushnailbarbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2866933479710100417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lush-nail-bar",
      "poi_latitude": "36.0605497",
      "poi_longitude": "-95.7812487",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-994-6399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7yXg2qLtocRwYvLZM9kySc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_730ab9e0-976e-4381-b845-4634aac5eebc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Saint Francis Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "10501 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-2eba-70e4-a0cc-144fb1d3221b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2eba-70e4-a0cc-144fb1d3221b",
        "storage_key": "property/6767906449167041/019d270e-2eba-70e4-a0cc-144fb1d3221b.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406794313894727694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital-south",
      "poi_latitude": "36.0333434",
      "poi_longitude": "-95.8576667",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4932-76ee-9912-e020860df96d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4932-76ee-9912-e020860df96d",
        "storage_key": "property/6767906449167041/019d270e-4932-76ee-9912-e020860df96d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXaxi3-OtocRDhBgtecRcv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4c01394e-a886-4394-986d-76a221400447",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Council Oak Comprehensive Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "10109 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-31b8-712c-a44f-083cf7299c3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-31b8-712c-a44f-083cf7299c3b",
        "storage_key": "property/6767906449167041/019d270e-31b8-712c-a44f-083cf7299c3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.creekhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3324838369463455816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "council-oak-comprehensive-healthcare",
      "poi_latitude": "36.0515562",
      "poi_longitude": "-95.863328",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-233-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4932-76ee-9912-e020860df96d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4932-76ee-9912-e020860df96d",
        "storage_key": "property/6767906449167041/019d270e-4932-76ee-9912-e020860df96d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3-HdVONtocRSFB1m-EyJC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_66b5fe67-4978-4b31-98de-66c4e29cf7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1205 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful Christmas light display with thousands of lights, synchronized music, and a train ride. They highlight the festive, joyful, and magical atmosphere, and the opportunity to enjoy hot chocolate and mini donuts. They also like the free admission and easy parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-31cc-72cb-8d1c-0cf0bf879fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-31cc-72cb-8d1c-0cf0bf879fd2",
        "storage_key": "property/6767906449167041/019d270e-31cc-72cb-8d1c-0cf0bf879fd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4937-70be-aa33-37693b33bc99",
        "storage_key": "property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fba3e5d3-cbe2-42da-b5e2-25dfe2caea81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including swings, slides, and climbing structures, as well as picnic tables and benches. They highlight the park's clean, well-maintained facilities, the ample shade provided by canopy coverings, and the fenced-in area for added safety. They also like the turf grass in play areas, which helps prevent mud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-3333-760b-8d14-3ada2b816f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3333-760b-8d14-3ada2b816f1e",
        "storage_key": "property/6767906449167041/019d270e-3333-760b-8d14-3ada2b816f1e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4937-70be-aa33-37693b33bc99",
        "storage_key": "property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_234f24b0-0b94-4e47-b22e-4421bafb8ff1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Vast county park boasting picnic area & playgrounds, plus an 18-hole championship disc golf course.",
      "poi_long_description": "People say this park offers clean walking trails, shaded picnic areas, and a playground. They highlight the peaceful and safe atmosphere, and the well-maintained facilities, including restrooms, grills, and charging stations. They also like the disc golf course and the availability of animal waste bags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-34a0-7551-8c2c-e9b18a44100e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-34a0-7551-8c2c-e9b18a44100e",
        "storage_key": "property/6767906449167041/019d270e-34a0-7551-8c2c-e9b18a44100e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4937-70be-aa33-37693b33bc99",
        "storage_key": "property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b00f122a-d41a-4af5-b3b9-37ef8d26bb32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ray Harral Nature Park & Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7101 S 3rd St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "40-acre park with a peaceful feel, an on-site nature center, picnic facilities & fishing.",
      "poi_long_description": "People say this park offers well-marked hiking trails, picnic areas, and a nature center with educational programs. They highlight the easy walking trails, fun nature center with cool information and stuff for kids, and the peaceful, remote feel despite being close to the city. They also like the guided full moon walks and the availability of supplies for pet owners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-382a-76ff-a683-87d57680cc4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-382a-76ff-a683-87d57680cc4b",
        "storage_key": "property/6767906449167041/019d270e-382a-76ff-a683-87d57680cc4b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/RayHarralNatureCenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3946947640467703348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ray-harral-nature-park--center",
      "poi_latitude": "35.984247",
      "poi_longitude": "-95.786704",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-615-6099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4937-70be-aa33-37693b33bc99",
        "storage_key": "property/6767906449167041/019d270e-4937-70be-aa33-37693b33bc99.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_BQieWItocRNMYkmfdfxjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_761a2be2-87fe-4bde-ba8f-8e15c564b208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Battle Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 N Battle Creek Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Public golf course offering multiple water challenges.",
      "poi_long_description": "People say this golf course offers challenging play and well-maintained greens. They highlight the reasonable rates and friendly staff. They also like the beautiful course and facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-370d-71c2-b634-c63b77c99bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-370d-71c2-b634-c63b77c99bea",
        "storage_key": "property/6767906449167041/019d270e-370d-71c2-b634-c63b77c99bea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.battlecreekgolf.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11341802120555861489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "battle-creek-golf-club",
      "poi_latitude": "36.0849383",
      "poi_longitude": "-95.8033736",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-355-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-4997-762b-9da6-4c14093107b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-4997-762b-9da6-4c14093107b7",
        "storage_key": "property/6767906449167041/019d270e-4997-762b-9da6-4c14093107b7.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2pBrXCLtocR8RWB7O8sZp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7126f65c-0cba-4c95-b4e8-921d078a9398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-37b5-72ff-bb81-eb133b83cf26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-37b5-72ff-bb81-eb133b83cf26",
        "storage_key": "property/6767906449167041/019d270e-37b5-72ff-bb81-eb133b83cf26.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d83dacc6-21a7-471a-aaaa-3ee6caaa3677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "City of Broken Arrow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 1st St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-39d6-75c1-b61b-98e517e840b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-39d6-75c1-b61b-98e517e840b0",
        "storage_key": "property/6767906449167041/019d270e-39d6-75c1-b61b-98e517e840b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981682047998685423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-broken-arrow",
      "poi_latitude": "36.0510555",
      "poi_longitude": "-95.7899817",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-452c-766b-b3a4-4f38aa4b887a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-452c-766b-b3a4-4f38aa4b887a",
        "storage_key": "property/6767906449167041/019d270e-452c-766b-b3a4-4f38aa4b887a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQP1vMOLtocR7_CiSld8R6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_aec467db-302a-451c-b648-ee88e8fefd97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "CCT",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7835 E 106th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-3c0c-77a2-abe4-6b8332a4772f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c0c-77a2-abe4-6b8332a4772f",
        "storage_key": "property/6767906449167041/019d270e-3c0c-77a2-abe4-6b8332a4772f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cct.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13720834206770318126&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cct",
      "poi_latitude": "36.0107418",
      "poi_longitude": "-95.8887703",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-794-8255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwaDBRiOtocRLsuS1AMyar4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_baf0d985-e510-4d12-814d-abacc3414bae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "The Galley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12626 S Memorial Dr, Bixby, OK 74008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-3cf7-75ad-8f06-d4d06853538e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3cf7-75ad-8f06-d4d06853538e",
        "storage_key": "property/6767906449167041/019d270e-3cf7-75ad-8f06-d4d06853538e.webp",
        "width": 1098,
        "height": 1280
      },
      "poi_business_url": "https://thegalley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17164344617237820771&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-galley",
      "poi_latitude": "35.9803984",
      "poi_longitude": "-95.8873715",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-375-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z49t8-PtocRYzXZIH0ANO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5142811c-6923-4b10-9445-bbc4964a08e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Jack Wills Companies - Warehouse and Corporate Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5891 S Garnett Rd, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-3c83-757d-aee1-9000c44a10c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c83-757d-aee1-9000c44a10c1",
        "storage_key": "property/6767906449167041/019d270e-3c83-757d-aee1-9000c44a10c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7832107266597974639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jack-wills-companies---warehouse-and-corporate-offices",
      "poi_latitude": "36.0774642",
      "poi_longitude": "-95.8493322",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-459-3730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-45da-76eb-bfa6-fa9d3d3ef497",
        "storage_key": "property/6767906449167041/019d270e-45da-76eb-bfa6-fa9d3d3ef497.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUX4BlaMtocRb_JTDBA8sWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_eb740258-e3cb-4861-9309-5f078771ddea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Leisure Park Elementary School",
      "poi_type": "Education",
      "poi_address": "4300 S Juniper Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/lpes",
      "poi_directions_map_url": "https://maps.google.com/?cid=6686773643555686078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "leisure-park-elementary-school",
      "poi_latitude": "36.0093143",
      "poi_longitude": "-95.8053088",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-259-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWioUjeJtocRvsaUZTMxzFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9558f5fb-52bd-4aa1-81b1-3a9f5cad3c7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Lynn Wood Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 W Quincy St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/lwes",
      "poi_directions_map_url": "https://maps.google.com/?cid=1805196987323033086&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lynn-wood-elementary-school",
      "poi_latitude": "36.038586",
      "poi_longitude": "-95.8076889",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-259-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM1oupP2LtocR_qX-ehhZDRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_4a86d017-8c95-4063-b93e-b9d3cf2594dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ernest Childers Middle School",
      "poi_type": "Education",
      "poi_address": "301 E Tucson St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.baschools.org/o/chms",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017264766830596586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ernest-childers-middle-school",
      "poi_latitude": "35.9873738",
      "poi_longitude": "-95.785557",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-259-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9QaRqeSItocR6lEZi9guCvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_cff3c93e-4ad0-4049-9913-8d350461084e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Oliver Middle School",
      "poi_type": "Education",
      "poi_address": "3100 W New Orleans St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-268f-717f-9d61-40fa113deb4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-268f-717f-9d61-40fa113deb4a",
        "storage_key": "property/6767906449167041/019d7917-268f-717f-9d61-40fa113deb4a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.baschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11642383297385948844&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oliver-middle-school",
      "poi_latitude": "36.0189359",
      "poi_longitude": "-95.8270601",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-259-4590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYbCXK92LtocRrGahy-wNkqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4ed69db2-45d9-403e-9830-69eedf766bc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Broken Arrow High School",
      "poi_type": "Education",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-269a-7299-a643-150462069323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-269a-7299-a643-150462069323",
        "storage_key": "property/6767906449167041/019d7917-269a-7299-a643-150462069323.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baschools.org/o/bahs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9874418802231035849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-high-school",
      "poi_latitude": "36.0739737",
      "poi_longitude": "-95.766474",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-259-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOVb0n1GKtocRyUdrbpX7CIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_208ef8e2-f422-4953-a085-f6cf6fec65c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Union High School Freshman Academy",
      "poi_type": "Education",
      "poi_address": "7616 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-2635-716b-963a-3659c36447d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2635-716b-963a-3659c36447d1",
        "storage_key": "property/6767906449167041/019d7917-2635-716b-963a-3659c36447d1.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://ufa.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11673188432274153300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-freshman-academy",
      "poi_latitude": "36.0524715",
      "poi_longitude": "-95.8526699",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-357-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSlfnDaMtocRVF_mLQh__6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f36f86fe-2cfc-4cdc-b126-18cf0461bc96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Summit Christian Academy",
      "poi_type": "Education",
      "poi_address": "200 E Broadway Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-2686-75b0-b442-dc4e794bd455.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2686-75b0-b442-dc4e794bd455",
        "storage_key": "property/6767906449167041/019d7917-2686-75b0-b442-dc4e794bd455.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.summit.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411921446695056607&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-christian-academy",
      "poi_latitude": "36.0527427",
      "poi_longitude": "-95.788597",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-251-1997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKULs3MOLtocR37SzEX-3ILo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f6e4ae02-f4f5-42ca-883c-d753d54ce261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Clary Sage College",
      "poi_type": "Education",
      "poi_address": "3131 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-2ed2-71ad-81ed-63c6d38c402c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2ed2-71ad-81ed-63c6d38c402c",
        "storage_key": "property/6767906449167041/019d7917-2ed2-71ad-81ed-63c6d38c402c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clarysagecollege.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13907947766092128129&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clary-sage-college",
      "poi_latitude": "36.1170274",
      "poi_longitude": "-95.9040243",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-298-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_aTKSKuStocRgd-bSM70AsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_2feadbd6-5bf1-4f4e-a0b5-d792d62d0047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-3224-7159-b569-fe26c3a321d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3224-7159-b569-fe26c3a321d0",
        "storage_key": "property/6767906449167041/019d7917-3224-7159-b569-fe26c3a321d0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.050518",
      "poi_longitude": "-95.9530171",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 24 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129f-7178-9e93-3f29714cb0e8",
        "storage_key": "property/6767906449167041/019cfb52-129f-7178-9e93-3f29714cb0e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d2eaa60e-c343-4e25-845d-04b803d240e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Caribbean Sushi",
      "poi_type": "Restaurants",
      "poi_address": "3708 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Island-inspired sushi & poke, offered in a colorful cafe setting with a wide variety of tea drinks.",
      "poi_long_description": "People say this sushi restaurant offers a wide variety of creative and unique rolls, including the popular Dragonballs and Tempura. They highlight the fresh and delicious food, with options for both meat eaters and vegetarians, and the fun and exciting dining experience. They also like the welcoming and friendly service provided by the management and staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-31bc-76dd-a5d5-a235e5dc0c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-31bc-76dd-a5d5-a235e5dc0c88",
        "storage_key": "property/6767906449167041/019d7917-31bc-76dd-a5d5-a235e5dc0c88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.caribbeansushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10286589007794756285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "caribbean-sushi",
      "poi_latitude": "36.0159308",
      "poi_longitude": "-95.798955",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-286-1306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8C7wECJtocRvVoLsDNOwY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_a52f9bc5-96bf-4390-837f-64874942f85d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Rustic Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "210 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Rustic steakhouse in the Rose District Plaza serving up choice cuts and other hearty fare, plus cocktails.",
      "poi_long_description": "People say this chophouse restaurant serves delicious steaks, crab cakes, and lobster bisque. They also highlight the cozy and elegant atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-30e5-750c-87d4-471362a08abb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-30e5-750c-87d4-471362a08abb",
        "storage_key": "property/6767906449167041/019d7917-30e5-750c-87d4-471362a08abb.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.rusticchophouseba.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410778395433896171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rustic-chophouse",
      "poi_latitude": "36.0509556",
      "poi_longitude": "-95.7910163",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-355-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0Fbt_-LtocR6wgaBE0V3tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_81ad2bb5-417b-48ba-8823-317e48c21410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ridge Grill",
      "poi_type": "Restaurants",
      "poi_address": "9999 S Mingo Rd Suite G, Tulsa, OK 74133, USA",
      "poi_short_description": "Seafood, steaks & a Sunday brunch menu presented in a polished setting with a full bar.",
      "poi_long_description": "People say this restaurant serves delicious beef stroganoff and prime rib. They also highlight the attentive service and enjoyable atmosphere, especially on the patio.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-3a6b-7585-81cb-da37e557122b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3a6b-7585-81cb-da37e557122b",
        "storage_key": "property/6767906449167041/019d7917-3a6b-7585-81cb-da37e557122b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10260267212738921926&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridge-grill",
      "poi_latitude": "36.0188225",
      "poi_longitude": "-95.867276",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-994-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf-6rmUSOtocRxgXkM6vKY44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_da7d6808-7f4b-4dc3-88d9-c201450f4ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Pita Place Mediterranean Grill",
      "poi_type": "Restaurants",
      "poi_address": "8315 East 111th St S Suite A, Bixby, OK 74008, USA",
      "poi_short_description": "Mediterranean restaurant offering gyros, kabobs and falafel plus a lunch buffet .",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious falafel, tabouli, and other Mediterranean dishes. They highlight the fresh, flavorful, and authentic ingredients, and the reasonable prices. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-412f-7197-84e7-dab8da85975b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-412f-7197-84e7-dab8da85975b",
        "storage_key": "property/6767906449167041/019d7917-412f-7197-84e7-dab8da85975b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pita-place.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5956267159734048032&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pita-place-mediterranean-grill",
      "poi_latitude": "36.0032497",
      "poi_longitude": "-95.8849097",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-394-9383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8xYcTmOtocRINVFk2zpqFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_61ce4816-2810-497d-99b8-da803c5e0e64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1101 N 20th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious burgers, steaks, and the triple dipper appetizer. They also highlight the friendly and attentive service, and the clean atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-4251-746e-b1a5-dcf0eb772174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4251-746e-b1a5-dcf0eb772174",
        "storage_key": "property/6767906449167041/019d7917-4251-746e-b1a5-dcf0eb772174.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/oklahoma/broken-arrow/broken-arrow?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=2743224776663522942&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "36.06155",
      "poi_longitude": "-95.764859",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-355-9456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbzYu0mKtocRfl4UcGbkESY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ffe3bc42-e336-40d9-87e7-71975b41e896",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "7 Brew Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1104 W New Orleans St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Energetic, modern drive-thru chain offering hot and cold coffee drinks (including sugar-free varieties), plus smoothies and energy beverages.",
      "poi_long_description": "People say this coffee shop offers delicious coffees and refreshing lemonades. They highlight the fair prices and the rewarding loyalty program. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-490c-73eb-bc48-349481deebdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-490c-73eb-bc48-349481deebdf",
        "storage_key": "property/6767906449167041/019d7917-490c-73eb-bc48-349481deebdf.webp",
        "width": 1280,
        "height": 523
      },
      "poi_business_url": "https://7brew.com/location/oklahoma-broken-arrow-000037",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323809288185489692&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "7-brew-coffee",
      "poi_latitude": "36.0177268",
      "poi_longitude": "-95.8027673",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 539-250-4502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12bc-73b8-b807-69ccb5593bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12bc-73b8-b807-69ccb5593bb3",
        "storage_key": "property/6767906449167041/019cfb52-12bc-73b8-b807-69ccb5593bb3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJccuUmBSJtocRHKk4Qlf44Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_6d8aa0c8-5acb-440d-94de-72a8bdc089e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "1640 W Tucson St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop offers a variety of drinks, including frappes and refreshers. They also highlight the friendly and helpful service, and the fast drive-through.\n\nSome reviews mention the drinks can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-4dee-768b-bda9-2dbf2dd9032f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4dee-768b-bda9-2dbf2dd9032f",
        "storage_key": "property/6767906449167041/019d7917-4dee-768b-bda9-2dbf2dd9032f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1022243",
      "poi_directions_map_url": "https://maps.google.com/?cid=1572099661551094445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "35.9888617",
      "poi_longitude": "-95.8088963",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-404-8968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12bc-73b8-b807-69ccb5593bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12bc-73b8-b807-69ccb5593bb3",
        "storage_key": "property/6767906449167041/019cfb52-12bc-73b8-b807-69ccb5593bb3.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJnT7xcM2JtocRrcpDFlA40RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_8b21dbcc-584d-4900-b6a0-0a65692b351c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Arby's",
      "poi_type": "Restaurants",
      "poi_address": "3325 S Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Fast-food chain, known for its roast beef, serving up hot & cold sandwiches, fries & shakes.",
      "poi_long_description": "Fast-food chain, known for its roast beef, serving up hot & cold sandwiches, fries & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-4e96-736b-8995-f9f6aafd2734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4e96-736b-8995-f9f6aafd2734",
        "storage_key": "property/6767906449167041/019d7917-4e96-736b-8995-f9f6aafd2734.webp",
        "width": 970,
        "height": 1280
      },
      "poi_business_url": "http://www.arbys.com/locations/us/ok/broken-arrow/3325-s-elm-place/store-6761?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAyMzUyMzcxNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5186553124415866790&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arby-s",
      "poi_latitude": "36.0177737",
      "poi_longitude": "-95.7967883",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-449-0025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_fG0HkGJtocRpgeATZZW-kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f871ab69-45b6-47c1-b687-9d4027288c80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Wendy's",
      "poi_type": "Restaurants",
      "poi_address": "4703 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_long_description": "People say this fast food restaurant serves good chili and hamburgers.\n\nOther reviews mention the food can be cold and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-4efa-77a8-844e-742810fa67c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4efa-77a8-844e-742810fa67c2",
        "storage_key": "property/6767906449167041/019d7917-4efa-77a8-844e-742810fa67c2.webp",
        "width": 555,
        "height": 495
      },
      "poi_business_url": "https://locations.wendys.com/united-states/ok/broken-arrow/4703-s-elm-place?utm_source=Yext&utm_medium=Google_My_Business&utm_campaign=Local_Search",
      "poi_directions_map_url": "https://maps.google.com/?cid=9497913415181357941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wendy-s",
      "poi_latitude": "36.0041202",
      "poi_longitude": "-95.7968947",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-398-0117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxcWSyOJtocRdVNN0-1dz4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_51316a94-0b10-4146-a4d1-89c91dcc1b82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Taco Bell",
      "poi_type": "Restaurants",
      "poi_address": "1811 W Norfolk Dr, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fast-food chain serving Mexican-inspired fare such as tacos, quesadillas & nachos.",
      "poi_long_description": "People say this fast food restaurant offers good tacos.\n\nOther reviews mention the food can be poorly prepared and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-553b-71a4-a67a-5b1f2b31c5e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-553b-71a4-a67a-5b1f2b31c5e9",
        "storage_key": "property/6767906449167041/019d7917-553b-71a4-a67a-5b1f2b31c5e9.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "https://locations.tacobell.com/ok/broken-arrow/1811-w--norfolk-drive.html?utm_source=yext&utm_campaign=googlelistings&utm_medium=referral&utm_term=041873&utm_content=website&y_source=1_MTA2NTQxOTI3Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11125668472269278090&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "taco-bell",
      "poi_latitude": "35.99442700000001",
      "poi_longitude": "-95.812627",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-888-5101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-12a2-752a-b4c4-f3fdf89a4a01",
        "storage_key": "property/6767906449167041/019cfb52-12a2-752a-b4c4-f3fdf89a4a01.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UYEHQCJtocRiotfeodQZpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_58b99a2e-381d-47ee-8877-b6b88e4ee2ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6310 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Wide selection of items including electronics, home furniture, clothing, toys, and baby gear.",
      "poi_long_description": "People say this department store offers a wide variety of products and is clean and organized.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-f529-7018-b3f3-717962a15d13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb51-f529-7018-b3f3-717962a15d13",
        "storage_key": "property/6767906449167041/019cfb51-f529-7018-b3f3-717962a15d13.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3295-broken-arrow-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13803958368995643297&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.9918222",
      "poi_longitude": "-95.8008118",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-455-4354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc78tJ9-ItocRoQ9EBgCDkb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d06a7013-0ad6-40eb-9e94-5329ed052994",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1150 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the friendly and helpful service, and the clean and organized store.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-5b80-77ab-bc25-e9dd3630195c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5b80-77ab-bc25-e9dd3630195c",
        "storage_key": "property/6767906449167041/019d7917-5b80-77ab-bc25-e9dd3630195c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/broken-arrow/2422",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603451760596788981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0670278",
      "poi_longitude": "-95.7765664",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-615-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjSo4zLOLtocR9abs_ADiqco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_65c985b0-2080-493c-8e16-8293e8770edd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-5b5f-72db-9bd5-20120de36d24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5b5f-72db-9bd5-20120de36d24",
        "storage_key": "property/6767906449167041/019d7917-5b5f-72db-9bd5-20120de36d24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_6076661b-b552-4130-9735-fb6636eb5c5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-5d1e-702b-bfff-e325fdaaecb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5d1e-702b-bfff-e325fdaaecb3",
        "storage_key": "property/6767906449167041/019d7917-5d1e-702b-bfff-e325fdaaecb3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_d72ab502-ade0-47cc-8190-9e63196ce211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a good selection of products and courteous staff. They also highlight the rewards program, which can be helpful for saving money on future purchases.\n\nSome reviews mention the self-checkout can be frustrating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-2f17-769a-921d-476ec9504834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb52-2f17-769a-921d-476ec9504834",
        "storage_key": "property/6767906449167041/019cfb52-2f17-769a-921d-476ec9504834.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Broken-Arrow/1536?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1536-_-na-_-0-_-0&y_source=1_MTE4NDM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318214238171197715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "36.0650786",
      "poi_longitude": "-95.7677884",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-355-4926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5dy-UuKtocRE3FavZUW86o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ac2bdd7b-4de9-4e9f-9b28-bd846209cc27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "3612 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-f89b-75a5-8a4f-a21dabac6747.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb51-f89b-75a5-8a4f-a21dabac6747",
        "storage_key": "property/6767906449167041/019cfb51-f89b-75a5-8a4f-a21dabac6747.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6406606517098865869&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "36.0164678",
      "poi_longitude": "-95.7992957",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-449-9323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnejRM0eJtocRzWRhA6_W6Fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_83d73dc9-487c-462f-a864-4edd355aaafd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "525 W Tucson St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Shoppers say this supermarket offers a good selection of groceries at affordable prices, with fresh produce and high-quality store brands. They also highlight the clean and well-organized store, and friendly and helpful employees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-65db-70c8-b1f9-ebc75ec3ebb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-65db-70c8-b1f9-ebc75ec3ebb0",
        "storage_key": "property/6767906449167041/019d7917-65db-70c8-b1f9-ebc75ec3ebb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/broken-arrow/525-w-tucson-st/f257",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072427690360315802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.987763",
      "poi_longitude": "-95.7957967",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-136d-70ad-b38f-d97cbabd4db9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-136d-70ad-b38f-d97cbabd4db9",
        "storage_key": "property/6767906449167041/019cfb52-136d-70ad-b38f-d97cbabd4db9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa6sGUGJtocRmh8AurR0oyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_c25ea329-98d1-4cae-85ce-a3bb7f6e29c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "1907 | Oklahoma Mercantile & Eatery",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 E Fort Worth St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Apparel, gifts, and home goods with Oklahoma themes, plus custom embroidery and laser engraving.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-676b-7638-b9df-9a95f21061db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-676b-7638-b9df-9a95f21061db",
        "storage_key": "property/6767906449167041/019d7917-676b-7638-b9df-9a95f21061db.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.1907ok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7295512606516694759&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "1907-oklahoma-mercantile-eatery",
      "poi_latitude": "36.048033",
      "poi_longitude": "-95.7897266",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-806-8579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH62tN8KLtocR587P9Q_ePmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_b2143bd3-d78a-40c3-b5dd-a9e14980ad4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Bass Pro Drive, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of hunting, fishing, and outdoor gear, as well as clothing and home decor. They highlight the fun and festive atmosphere, especially during the holidays, and the interesting attractions like the fish tanks and trout pond. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-67fb-77d4-b4cb-6e0d1e028de2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-67fb-77d4-b4cb-6e0d1e028de2",
        "storage_key": "property/6767906449167041/019d7917-67fb-77d4-b4cb-6e0d1e028de2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/ok/broken-arrow/101-bass-pro-dr.html?y_source=1_MzAxMTUyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650999968817088325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "36.0709381",
      "poi_longitude": "-95.7921204",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-355-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-129d-76db-ad82-004983e252c3",
        "storage_key": "property/6767906449167041/019cfb52-129d-76db-ad82-004983e252c3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSZm66KLtocRRQea6djOUss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_08e64c88-f5cd-4826-acf4-cec2b5c4f41b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of aquatic creatures, including sharks, sea turtles, and jellyfish, as well as some land animals. They highlight the interactive experiences, such as touch tanks and feeding opportunities, and the well-maintained exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-6858-71df-ac22-d29cf678343a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6858-71df-ac22-d29cf678343a",
        "storage_key": "property/6767906449167041/019d7917-6858-71df-ac22-d29cf678343a.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-1369-7284-ba1f-05c57db569ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-1369-7284-ba1f-05c57db569ac",
        "storage_key": "property/6767906449167041/019cfb52-1369-7284-ba1f-05c57db569ac.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_14c90ce9-5934-4ccd-861d-d5f3f953d275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Entertainment",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Large city park with ample facilities including sports fields & courts, a pool, playgrounds & golf.",
      "poi_long_description": "Visitors say this park offers a scenic walking trail, playgrounds, and a well-maintained golf course with helpful instructors. They also highlight the family-friendly atmosphere, abundance of shade, and the presence of public restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-6e59-77cb-98a9-abf2efcfa02c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6e59-77cb-98a9-abf2efcfa02c",
        "storage_key": "property/6767906449167041/019d7917-6e59-77cb-98a9-abf2efcfa02c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-16e6-707a-958c-2d247ad220cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-16e6-707a-958c-2d247ad220cf",
        "storage_key": "property/6767906449167041/019cfb52-16e6-707a-958c-2d247ad220cf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59eec577-4d63-4827-92af-e0c4fb99f7a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Regal Warren Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "1700 Aspen Creek Dr, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_long_description": "People say this movie theater offers reclining seats, heated seats, and a balcony experience. They highlight the comfortable seating, clean facilities, and friendly staff. They also like the concessions, which include popcorn and adult beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-6e9b-7289-9be0-d25d58879cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6e9b-7289-9be0-d25d58879cac",
        "storage_key": "property/6767906449167041/019d7917-6e9b-7289-9be0-d25d58879cac.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-broken-arrow-1448?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6017797638634288047&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-broken-arrow",
      "poi_latitude": "35.9913186",
      "poi_longitude": "-95.8096298",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-136f-7391-9125-b842315e0522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-136f-7391-9125-b842315e0522",
        "storage_key": "property/6767906449167041/019cfb52-136f-7391-9125-b842315e0522.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3CO8bGJtocRrzP7lBGDg1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_260385c6-9a50-49dd-a255-e9f27c0c31d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-7163-72a3-9b20-78e3631072e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-7163-72a3-9b20-78e3631072e7",
        "storage_key": "property/6767906449167041/019d7917-7163-72a3-9b20-78e3631072e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "17.3 mi",
      "poi_walking_minutes": "6 hours 23 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-136b-763d-9931-cb68e142fadb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-136b-763d-9931-cb68e142fadb",
        "storage_key": "property/6767906449167041/019cfb52-136b-763d-9931-cb68e142fadb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a289c49e-2364-4f80-baab-2a62b6bf3429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Entertainment",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park featuring an adventure playground, a sensory garden, a picnic area, eateries & more.",
      "poi_long_description": "People say this park offers a wide variety of activities, including playgrounds, water features, walking trails, and opportunities to feed fish. They highlight the beautiful, well-maintained grounds, the fun and interactive experiences for families, and the ample parking. They also like the availability of restrooms, food, and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-7507-73e0-8325-f0625e3a362f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-7507-73e0-8325-f0625e3a362f",
        "storage_key": "property/6767906449167041/019d7917-7507-73e0-8325-f0625e3a362f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 26 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-16e6-707a-958c-2d247ad220cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-16e6-707a-958c-2d247ad220cf",
        "storage_key": "property/6767906449167041/019cfb52-16e6-707a-958c-2d247ad220cf.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e124ac19-2aa2-4658-8634-b2cbb5283ebc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Interactive kids' science museum & play center offering educational exhibits & DIY crafts.",
      "poi_long_description": "People say this children's museum offers a variety of fun, interactive, and educational activities suitable for all ages. They highlight the reasonable prices and the engaging, stimulating environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019d7917-7467-71d9-aa88-f86aead9916f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-7467-71d9-aa88-f86aead9916f",
        "storage_key": "property/6767906449167041/019d7917-7467-71d9-aa88-f86aead9916f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "17.1 mi",
      "poi_walking_minutes": "6 hours 15 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-136b-763d-9931-cb68e142fadb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb52-136b-763d-9931-cb68e142fadb",
        "storage_key": "property/6767906449167041/019cfb52-136b-763d-9931-cb68e142fadb.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7801a49d-af17-4e4e-b66b-3aa68cdd2c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cebc0b76-0ac1-4e86-b43c-5e3227bd82d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ridge Cantina",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "ridge-cantina",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c557397-931d-47ba-8738-634cfeb15a45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Genghis Grill",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "genghis-grill",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0949aa1-0dfc-4a1a-8294-e0df99d4f1dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "poi_name": "Ziggi’s Cafe",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "ziggi-s-cafe",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c505fbad6748ba58bf1566ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_feff81d0ea1eae698a22dad9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_238501e1c1c07f820fc32d82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_e4770c66288f36eba8ed973d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_fc697271e63cc0750d6d2352",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b4fcd003fcb746e0539e27a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0fd9e6c4-9806-4835-bfba-b84c4d020811",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "rating": "5.0",
      "name": "R. Jada Edwards",
      "text": "Lovely place to live!! My husband and I have lived here for 11 months and have no complaints! The application process and move-in were flawless. I've submitted a total of 3 maintenance requests and all were addressed immediately and to our satisfaction! The leasing agents, managers, maintenance crew, and porters are all professional, friendly, and work very hard! I've worked with Kimberly several times and she is always smiling, upbeat, and helpful! Our 3rd-floor apartment is beautiful and comfortable! The A/C and heat are efficient, much to my surprise, being on the 3rd floor! The pool, fitness center, computer area, and clubhouse are top-notch, and we feel more secure having a coded entry gate! Besides children playing and a barking dog once in a while, there's not much outdoor noise! The way the apartments are designed, there's very little neighbor noise!!  I highly recommend The Icon Apartments!",
      "date": "2025-10-26",
      "title": ""
    },
    {
      "id": "custom_90fbcceb-e1a2-40e9-858f-2f26b94b12e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "rating": "5.0",
      "name": "Barbara Heinrich",
      "text": "When I decided to move into ICON, I was so excited to live in a complex that had beautiful apartments, and friendly staff that cared about thier residents.  Thank you all for your courtesy and dedication  to your professions.\nThank you to maintence staff for thier prompt response t my requests. Kudos.",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_4854a69d-eecc-476f-a90a-d74fbc4219ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "rating": "5.0",
      "name": "angela hilton",
      "text": "I have enjoyed my life here.  Everyone is so nice. The staff in the office is friendly. The maintenance are really good about responding to needs especially air conditioning issues",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_392ae9be-a656-4abf-a595-a950a5de325d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "rating": "5.0",
      "name": "Harley Whistance",
      "text": "Love living here. Management and maintenance are great and the property is well tended to. My upstairs neighbor is a little discourteous and noisy every so often, but that’s no fault of Icon’s. Great facility in a great area.",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6c41daca-27ba-4650-9701-5722e27a37ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-b12f-72ce-9e54-09526a15d7ef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree virtual tour of the community swimming pool and apartment buildings.",
        "public_id": "019cfb52-b12f-72ce-9e54-09526a15d7ef",
        "storage_key": "property/6767906449167041/019cfb52-b12f-72ce-9e54-09526a15d7ef.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Icon at Broken Arrow Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d5a019984540c277a02e1&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-3b37-714b-ae67-090a6986929e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "icon-at-broken-arrow-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041"
    },
    {
      "lead_collector_id": "019cf79e-3baa-735e-85cf-2df541caf897",
      "lead_source": "LANDING_PAGE",
      "name": "icon-at-broken-arrow-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-broken-arrow-ok",
      "search_query": "pet friendly apartments Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Broken Arrow, OK",
      "h2_subtitle": "Discover pet-friendly living at Icon at Broken Arrow Apartments. Our community welcomes pets, ensuring a comfortable home for you and your furry friends.",
      "page_copy": "If you're searching for pet-friendly apartments in Broken Arrow, OK, look no further than Icon at Broken Arrow Apartments. Our community offers the perfect blend of comfort and convenience, catering to both you and your furry companions. Nestled in the beautiful city of Broken Arrow, our apartments feature spacious, welcoming environments and a warm community atmosphere, ensuring you and your pets feel right at home.\n\nEnjoy a variety of amenities designed for pet owners and their pets alike. From our wood-burning fireplaces where you can relax with your pet by your side, to our gated community offering peace of mind, we prioritize your comfort and security. Additionally, our internet cafe with a gourmet coffee and tea bar provides a cozy spot to unwind. At Icon at Broken Arrow Apartments, we offer more than just a pet-friendly policy; we provide a home where you and your pets can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Broken Arrow, OK",
      "seo_description": "Explore pet-friendly living at Icon at Broken Arrow Apartments in Broken Arrow, OK. Perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-with-a-pool-tulsa-county",
      "search_query": "apartments with a pool in Tulsa County",
      "category": "Amenity",
      "h1_title": "Enjoy Apartments with a Pool in Tulsa County",
      "h2_subtitle": "Discover refreshing poolside living at Icon at Broken Arrow Apartments, located in Tulsa County. Dive into relaxation in our exclusive community pool.",
      "page_copy": "Icon at Broken Arrow Apartments in Tulsa County offers a serene retreat with luxurious features like an exclusive community pool. Perfectly blending luxury and leisure, our apartments provide the ideal setting for relaxation and enjoyment in the beautiful Tulsa County area. Our pool area is the perfect place to unwind, whether you're looking to take an invigorating swim or simply relax by the water's edge.\n\nLocated in the vibrant community of Broken Arrow, our apartments offer more than just a pool. Enjoy unique amenities like a wood-burning fireplace for cozy evenings, limited access gates for peace of mind, and an inviting internet cafe featuring a gourmet coffee and tea bar. With dedicated 24-hour emergency maintenance and handicapped-accessible options, Icon at Broken Arrow Apartments promises a comfortable, stress-free lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Tulsa County",
      "seo_description": "Relax at Icon at Broken Arrow Apartments, featuring a refreshing pool and located in beautiful Tulsa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-74011",
      "search_query": "air conditioned apartments near 74011",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 74011",
      "h2_subtitle": "Stay cool at Icon at Broken Arrow Apartments, located conveniently near the 74011 area. Our homes offer efficient air conditioning for your comfort.",
      "page_copy": "Living comfortably in a climate-controlled environment is easy at Icon at Broken Arrow Apartments near the 74011 area. Our air-conditioned apartments provide you with a refreshing haven from the Oklahoma heat, ensuring a cool and pleasant living space all year round. Located in the sought-after area of Broken Arrow, you'll find our community is perfectly positioned for comfort and convenience.\n\nIcon at Broken Arrow Apartments is more than just a cool place to live. We offer an array of amenities designed to enhance your lifestyle, from our inviting internet cafe with gourmet coffee and tea, to the peace of mind offered by limited access gates and 24-hour emergency maintenance services. Discover a community where comfort meets convenience, right here near 74011.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 74011",
      "seo_description": "Stay comfortable at Icon at Broken Arrow Apartments near 74011, offering air-conditioned homes and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-broken-arrow",
      "search_query": "apartments with dog park in Broken Arrow",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Park in Broken Arrow",
      "h2_subtitle": "Find the perfect home for you and your pet at Icon at Broken Arrow Apartments. Enjoy nearby spaces for your pets to play and thrive in Broken Arrow.",
      "page_copy": "Icon at Broken Arrow Apartments is the ideal community for pet lovers searching for apartments with easy access to dog parks in Broken Arrow. While our community itself offers exceptional amenities including secure, limited access gates and 24-hour emergency maintenance, we're also conveniently located near local dog parks, ensuring your furry friends have ample space to roam and play.\n\nOur pet-friendly atmosphere allows you and your canine companions to enjoy nearby recreational areas dedicated to pets. After a fun day out, return home to our inviting apartments, where you can unwind by the wood-burning fireplace or relax at our internet cafe, while sipping on gourmet coffee or tea. Choose Icon at Broken Arrow Apartments for a welcoming environment catering to both you and your pets.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Park in Broken Arrow",
      "seo_description": "Discover pet-friendly living at Icon at Broken Arrow Apartments, near dog parks and dedicated pet spaces in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "energy-efficient-appliances-broken-arrow-apartments",
      "search_query": "energy efficient appliances Broken Arrow apartments",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Broken Arrow",
      "h2_subtitle": "Explore Icon at Broken Arrow Apartments, featuring energy efficient appliances. Our homes offer sustainable living in the heart of Broken Arrow.",
      "page_copy": "Experience sustainable living at Icon at Broken Arrow Apartments, where energy efficient appliances are a standard feature in our homes. Located in the charming city of Broken Arrow, our apartments are designed for an eco-friendly lifestyle, helping you reduce energy consumption while enjoying modern conveniences.\n\nIn addition to energy efficient appliances, our community offers a range of amenities that enhance both comfort and convenience, including a cozy wood-burning fireplace and an inviting internet cafe complete with a gourmet coffee and tea bar. With features like limited access gates and 24-hour emergency maintenance, Icon at Broken Arrow Apartments provides a comprehensive living experience in Broken Arrow that caters to both sustainability and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Broken Arrow Apartments",
      "seo_description": "Live sustainably at Icon at Broken Arrow Apartments, featuring energy efficient appliances and modern living in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-broken-arrow-ok",
      "search_query": "two bedroom apartments broken arrow ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "h2_subtitle": "Discover spacious two bedroom layouts at Icon at Broken Arrow Apartments. Perfectly situated in Broken Arrow, OK, our homes offer comfort and style.",
      "page_copy": "Searching for two bedroom apartments in Broken Arrow, OK? Look no further than Icon at Broken Arrow Apartments, where our spacious two-bedroom layouts offer ample room for relaxation and daily living. Each apartment is designed with modern style and functionality in mind, making it a great fit for singles, roommates, or small families.\n\nLocated in the welcoming community of Broken Arrow, OK, you will appreciate our array of amenities such as limited access gates, a cozy wood-burning fireplace, and an internet cafe featuring gourmet coffee and tea. Plus, with our dedicated 24-hour emergency maintenance, you'll have peace of mind knowing assistance is always available. Choose Icon at Broken Arrow Apartments for well-appointed two-bedroom living in an exceptional location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Broken Arrow, OK",
      "seo_description": "Explore spacious two bedroom apartments at Icon at Broken Arrow, offering comfort and modern amenities in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-74011",
      "search_query": "one bedroom apartments near 74011",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 74011",
      "h2_subtitle": "Find your perfect one bedroom apartment at Icon at Broken Arrow. Located near 74011, our apartments offer comfort and convenience.",
      "page_copy": "Discover the perfect one bedroom living space at Icon at Broken Arrow Apartments, conveniently located near the 74011 area. Our community offers thoughtfully designed one bedroom apartments that provide the perfect balance of comfort, style, and functionality, ideal for singles or couples looking to live close to Broken Arrow's charming amenities.\n\nAt Icon at Broken Arrow, you can relax with features like a cozy wood-burning fireplace, or enjoy a beverage at our internet cafe complete with a gourmet coffee and tea bar. Our community also boasts limited access gates and 24-hour emergency maintenance, ensuring peace of mind. Choose Icon at Broken Arrow Apartments for one bedroom living near 74011, where quality and convenience come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 74011",
      "seo_description": "Icon at Broken Arrow offers one bedroom apartments near 74011, featuring modern amenities and convenient access in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-tcc-southeast-campus-broken-arrow",
      "search_query": "apartments near Tulsa Community College Southeast Campus Broken Arrow",
      "category": "School",
      "h1_title": "Apartments Near TCC Southeast Campus",
      "h2_subtitle": "Explore living at Icon at Broken Arrow Apartments, conveniently located near Tulsa Community College Southeast Campus in Broken Arrow.",
      "page_copy": "Icon at Broken Arrow Apartments provides the perfect residence for students and professionals seeking apartments near Tulsa Community College Southeast Campus in Broken Arrow. Our community offers a comfortable and modern living environment just a short drive from the campus, giving you easy access to your academic pursuits and campus events.\n\nOur range of amenities, such as the cozy wood-burning fireplaces and the internet cafe with a gourmet coffee and tea bar, cater to a variety of lifestyle needs. Additionally, our limited access gates and 24-hour emergency maintenance services ensure a secure and responsive living experience. Choose Icon at Broken Arrow Apartments for a convenient and enjoyable living arrangement near TCC Southeast Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near TCC Southeast Campus",
      "seo_description": "Live close to Tulsa Community College Southeast Campus. Icon at Broken Arrow offers comfortable apartments with modern amenities in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-nsu-broken-arrow-ok",
      "search_query": "apartments close to Northeastern State University Broken Arrow OK",
      "category": "School",
      "h1_title": "Apartments Near NSU Broken Arrow, OK",
      "h2_subtitle": "Discover comfortable living at Icon at Broken Arrow Apartments, conveniently close to Northeastern State University in Broken Arrow, OK.",
      "page_copy": "Experience the convenience of living in apartments close to Northeastern State University in Broken Arrow, OK, at Icon at Broken Arrow Apartments. Our community is ideal for students and faculty looking for a balance of comfort and proximity to campus activities and classes.\n\nAt Icon at Broken Arrow, you'll enjoy features like a welcoming wood-burning fireplace, perfect for relaxation after a day of studying. The internet cafe with gourmet coffee and tea is a great spot for group projects or solo study sessions. Further enhancing your living experience, we offer limited access gates and 24-hour emergency maintenance, providing peace of mind. Make your home at Icon at Broken Arrow, where convenience meets quality near NSU.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near NSU Broken Arrow, OK",
      "seo_description": "Icon at Broken Arrow offers apartments near Northeastern State University, providing modern amenities and convenience in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-south",
      "search_query": "apartments near saint francis hospital south tulsa county",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital South",
      "h2_subtitle": "Icon at Broken Arrow Apartments offers quality living close to Saint Francis Hospital South in Tulsa County, providing comfort and convenience.",
      "page_copy": "Icon at Broken Arrow Apartments is the ideal choice for those seeking apartments near Saint Francis Hospital South in Tulsa County. Our convenient location means healthcare professionals, patients, and their families can enjoy easy access to exceptional care and all the hospital's services while taking advantage of a comfortable home atmosphere.\n\nResidents will appreciate our community amenities, such as limited access gates for added security and an Internet cafe with a gourmet coffee and tea bar for relaxation or remote work. Enjoy the cozy ambiance of a wood-burning fireplace in select units. Choose Icon at Broken Arrow Apartments for a harmonious blend of modern living and accessibility near Saint Francis Hospital South.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital South",
      "seo_description": "Find comfortable living near Saint Francis Hospital South at Icon at Broken Arrow. Conveniently located in Tulsa County with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-council-oak-comprehensive-healthcare",
      "search_query": "broken arrow apartments close to council oak comprehensive healthcare",
      "category": "Hospital",
      "h1_title": "Broken Arrow Apartments Near Council Oak",
      "h2_subtitle": "Icon at Broken Arrow Apartments provides quality living close to Council Oak Comprehensive Healthcare, offering modern conveniences in a prime location.",
      "page_copy": "Discover unparalleled comfort at Icon at Broken Arrow Apartments, strategically situated close to Council Oak Comprehensive Healthcare. Our prime location in Broken Arrow ensures that healthcare professionals and patients can enjoy easy access to comprehensive healthcare services while benefiting from a serene living environment.\n\nIcon at Broken Arrow offers a host of amenities including a cozy wood-burning fireplace and an Internet cafe complete with a gourmet coffee and tea bar. Residents can also enjoy the peace of mind that comes with our limited access gates and 24-hour emergency maintenance. For those seeking Broken Arrow apartments with convenience and modern amenities close to Council Oak, Icon at Broken Arrow is the perfect choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Broken Arrow Apartments Near Council Oak",
      "seo_description": "Icon at Broken Arrow offers modern apartments near Council Oak Comprehensive Healthcare, combining comfort and convenience in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-broken-arrow-ok",
      "search_query": "apartments near Rhema Park Broken Arrow OK",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park, Broken Arrow",
      "h2_subtitle": "Ideal for outdoor enthusiasts, Icon at Broken Arrow Apartments offers luxurious living near Rhema Park in Broken Arrow, OK.",
      "page_copy": "Icon at Broken Arrow Apartments is the perfect home for those looking to be close to Rhema Park in Broken Arrow, OK. Our location is ideal for residents who enjoy outdoor activities, providing you with the opportunity to explore the beautiful landscapes and recreational opportunities that Rhema Park offers.\n\nIn addition to our convenient location, residents will love the amenities we provide, from a relaxing wood-burning fireplace in select units to an Internet cafe with gourmet coffee and tea bar. Our limited access gates and 24-hour emergency maintenance prioritize your safety and peace of mind. Choose Icon at Broken Arrow Apartments for a lifestyle that balances comfort and outdoor proximity next to Rhema Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park, Broken Arrow",
      "seo_description": "Live near the scenic Rhema Park at Icon at Broken Arrow, offering modern amenities and a convenient location in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "icon-apartments-near-elam-park",
      "search_query": "Icon at Broken Arrow near Elam Park",
      "category": "Park",
      "h1_title": "Icon at Broken Arrow Near Elam Park",
      "h2_subtitle": "Find your new home at Icon at Broken Arrow Apartments, conveniently located near Elam Park, offering modern living in a charming area.",
      "page_copy": "Experience a blend of comfort and convenience at Icon at Broken Arrow Apartments, nestled close to the serene Elam Park. Whether you're a nature enthusiast or just enjoy a tranquil morning stroll, our location provides you easy access to the natural beauty and recreational spaces of Elam Park.\n\nOur community offers an array of amenities designed with residents in mind. Enjoy the warmth of a wood-burning fireplace in select units or sip on your favorite beverage at our Internet cafe, complete with a gourmet coffee and tea bar. With limited access gates and 24-hour emergency maintenance, peace of mind is guaranteed. Icon at Broken Arrow combines the charm of park-side living with modern apartment comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Icon at Broken Arrow Near Elam Park",
      "seo_description": "Icon at Broken Arrow offers modern living near Elam Park, providing a unique lifestyle in a prime location with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "apartments-near-haikey-creek-park-broken-arrow",
      "search_query": "apartments close to Haikey Creek Park Broken Arrow",
      "category": "Park",
      "h1_title": "Apartments Close to Haikey Creek Park",
      "h2_subtitle": "Icon at Broken Arrow Apartments offers comfortable living just a short distance from the scenic Haikey Creek Park in Broken Arrow.",
      "page_copy": "Icon at Broken Arrow Apartments provides an ideal living environment for those who love the outdoors. Situated near Haikey Creek Park, our residents have easy access to lush landscapes and a variety of recreational activities in Broken Arrow.\n\nOur community features luxurious amenities designed to enhance your lifestyle. Select apartments boast a cozy wood-burning fireplace, while all residents can enjoy our Internet cafe complete with gourmet coffee and tea offerings. With peace of mind provided by limited access gates and 24-hour emergency maintenance, Icon at Broken Arrow successfully merges convenience and tranquility near Haikey Creek Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Haikey Creek Park",
      "seo_description": "Live near Haikey Creek Park at Icon at Broken Arrow, where modern amenities meet outdoor convenience in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167041",
      "source": "generator",
      "page_item_url": "nearby-apartments-ray-harral-nature-park-tulsa-county",
      "search_query": "Ray Harral Nature Park & Center nearby apartments Tulsa County",
      "category": "Park",
      "h1_title": "Apartments Near Ray Harral Nature Park",
      "h2_subtitle": "Enjoy the tranquility of nature at Icon at Broken Arrow Apartments, perfectly located near Ray Harral Nature Park & Center in Tulsa County.",
      "page_copy": "Find your peaceful retreat at Icon at Broken Arrow Apartments, conveniently located near the expansive Ray Harral Nature Park & Center in Tulsa County. Perfect for nature lovers, this proximity allows residents easy access to beautiful trails and natural landscapes, ideal for both relaxation and adventure.\n\nOur thoughtfully designed community offers exceptional amenities including select units with wood-burning fireplaces and an inviting Internet café featuring a gourmet coffee and tea bar. Enjoy the assurance of limited access gates alongside 24-hour emergency maintenance. Embrace the harmonious blend of comfort and natural beauty at Icon at Broken Arrow, near Ray Harral Nature Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Ray Harral Nature Park, Tulsa County",
      "seo_description": "Discover comfort and nature at Icon at Broken Arrow, near Ray Harral Nature Park & Center, offering modern amenities in Tulsa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5180"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-XGXH7FB08Z"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151050"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/icon-at-broken-arrow/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NW9CTDZV"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167041/019d1bd8-5182-7372-be4a-b01ab0e139fc.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-637-7213"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "644185411c75de40ee71c72a"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlN3N0RPYktrSFlSWnk4NjFXcFdaWVE9PSIsInZhbHVlIjoiTkZWSGF3czd6TWJXM0owTEZidlB5dz09IiwibWFjIjoiMTViNTVlNWIyYjE5MTI1Y2IzZGI2ZWNkYjdkZWVmMzE3OWRjMDBkNDBmNDk2YTNjNGZiY2JjM2E5OTU2ZDc2NiJ9"
    }
  ],
  "custom_qb_id": "5180",
  "custom_ga4_id": "G-XGXH7FB08Z",
  "custom_repli_id": "10041151050",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/icon-at-broken-arrow/register/",
  "custom_google_gtm_id": "GTM-NW9CTDZV",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167041/019d1bd8-5182-7372-be4a-b01ab0e139fc.pdf",
  "custom_ppc_tracking_phone_number": "800-637-7213",
  "custom_residentboost_apartment_id": "644185411c75de40ee71c72a",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlN3N0RPYktrSFlSWnk4NjFXcFdaWVE9PSIsInZhbHVlIjoiTkZWSGF3czd6TWJXM0owTEZidlB5dz09IiwibWFjIjoiMTViNTVlNWIyYjE5MTI1Y2IzZGI2ZWNkYjdkZWVmMzE3OWRjMDBkNDBmNDk2YTNjNGZiY2JjM2E5OTU2ZDc2NiJ9"
};

export const generatedAt = '2026-08-27T21:33:06.990Z';
